angular.module("billing.templates", ["main/src/billing-component/billing-component-directive.html", "main/src/billing-selection-and-review/billing-selection-and-review-page.html", "main/src/billing-wip-list/wip-list-directive.html", "main/src/common/invoice-date-selector/invoice-date-selector.html", "main/src/common/invoice-date-selector/invoice-due-date-selector.html", "main/src/common/send-modal.html", "main/src/create-statements/create-statements-directive.html", "main/src/detail-billing/billable/detail-billing-billable.html", "main/src/detail-billing/compose/add/db-compose-add-description-row.html", "main/src/detail-billing/compose/add/db-compose-add-fixed-fee.html", "main/src/detail-billing/compose/add/db-compose-add-flat-amount.html", "main/src/detail-billing/compose/add/db-compose-add-invoice-amounts.html", "main/src/detail-billing/compose/add/db-compose-add-time-and-expenses.html", "main/src/detail-billing/compose/add/db-compose-add-to-invoice-options.html", "main/src/detail-billing/compose/db-compose-froala-field.html", "main/src/detail-billing/compose/db-compose-invoice-error.html", "main/src/detail-billing/compose/db-compose-totals-summary.html", "main/src/detail-billing/compose/db-compose-view.html", "main/src/detail-billing/compose/db-compose.html", "main/src/detail-billing/compose/layout-fields/detail.html", "main/src/detail-billing/compose/layout-fields/group-1-amount.html", "main/src/detail-billing/compose/layout-fields/group-1-name.html", "main/src/detail-billing/compose/layout-fields/group-2-amount.html", "main/src/detail-billing/compose/layout-fields/group-2-name.html", "main/src/detail-billing/compose/layout-fields/group-3-amount.html", "main/src/detail-billing/compose/layout-fields/group-3-name.html", "main/src/detail-billing/compose/layout-fields/report-params.html", "main/src/detail-billing/detail-billing-directive.html", "main/src/detail-billing/detail-billing-receipts.html", "main/src/detail-billing/detail-billing-smart-bill-modal.html", "main/src/detail-billing/detail-billing-summary.html", "main/src/detail-billing/invoice-properties-dialog/invoice-properties-dialog.html", "main/src/detail-billing/multi-client-detail-billing-directive.html", "main/src/detail-billing/non-billable/detail-billing-non-billable.html", "main/src/detail-billing/preview/invoice-pdf-renderer.html", "main/src/fixed-fee-billing/fixed-fee-billing.html", "main/src/format-templates/format-templates-page.html", "main/src/format-templates/invoice-format-wizard.html", "main/src/format-templates/invoice-format-wizard/pages/accounts-receivable/invoice-format-wizard-accrec.html", "main/src/format-templates/invoice-format-wizard/pages/billing/invoice-format-wizard-billing.html", "main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-carousel-card.html", "main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-main.html", "main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-preview.html", "main/src/format-templates/invoice-formats-list.html", "main/src/format-templates/statement-format-wizard.html", "main/src/format-templates/statement-format-wizard/pages/accounts-receivable/statement-format-wizard-accrec.html", "main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-carousel-card.html", "main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-main.html", "main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-preview.html", "main/src/format-templates/statement-formats-list.html", "main/src/late-fees/late-fee-detail-grid-template.html", "main/src/late-fees/late-fee-detail.html", "main/src/late-fees/late-fees.html", "main/src/review-invoices/invoice-reversal-modal/invoice-reversal-modal.html", "main/src/review-invoices/review-invoices-directive.html", "main/src/user-preferences-setup/user-preferences-billing-component.html", "server-check/index.html"]);

angular.module("main/src/billing-component/billing-component-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/billing-component/billing-component-directive.html",
    "<ng-form id=\"billingComponentForm\" name=\"billingComponentForm\">\n" +
    "    <div class=\"col-md-12\" bento-busy-loader=\"vm.detail.isLoadingData()\" bento-busy-loader-size=\"small\" ng-if=\"billingComponentForm\">\n" +
    "        <bmp-page-header ng-if=\"vm.definition && !vm.definition.hideHeader\">\n" +
    "            <bmp-page-header-left-content>\n" +
    "                <h1>{{'Bluemoon.Billing.Component.CreateInvoice' | translate }}</h1>\n" +
    "            </bmp-page-header-left-content>\n" +
    "            <bmp-page-header-right-content>\n" +
    "                <button type=\"button\" id=\"billingComponentForm.save\" class=\"btn btn-primary\" data-ng-click=\"vm.detail.save()\" ng-disabled=\"vm.detail.isLoadingData()\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "                <button type=\"button\" id=\"billingComponentForm.cancel\" class=\"btn btn-default\" data-ng-click=\"vm.detail.cancel()\" ng-disabled=\"vm.detail.isLoadingData()\" data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "            </bmp-page-header-right-content>\n" +
    "        </bmp-page-header>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Invoice Number -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"invoiceNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoice.InvoiceNumber' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceNumber')\"\n" +
    "                class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\"\n" +
    "                    data-qe-id=\"bm-billingComponentForm-invoiceNumber-number\"\n" +
    "                    name=\"invoiceNumber\"\n" +
    "                    ng-model=\"vm.data.invoiceNumber\"\n" +
    "                    bmp-integer=\"true\"\n" +
    "                    min=\"0\" max=\"999999999\"\n" +
    "                    data-ng-disabled=\"vm.isInvoiceNumberDisabled()\"\n" +
    "                    data-bmp-entity-code=\"\"\n" +
    "                    data-bmp-entity-code-id=\"vm.data.partialInvoiceBilledId ? vm.data.partialInvoiceBilledId : vm.data.id\"\n" +
    "                    data-bmp-entity-code-type=\"invoices\"\n" +
    "                    data-bmp-entity-code-options=\"{typeId: 'INVOICE'}\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.PartialInvoice.InvoiceNumber\"\n" +
    "                    placeholder=\"{{'Bluemoon.Billing.DetailBilling.NextAvailablePlaceholder' | translate}}\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Date -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"invoiceDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoice.InvoiceDate' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDate')\"\n" +
    "                class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"invoiceDate\"\n" +
    "                                            name=\"invoiceDate\"\n" +
    "                                            ng-model=\"vm.data.$invoiceDate\"\n" +
    "                                            ng-required=\"true\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Override Total -->\n" +
    "            <div data-ng-if=\"!vm.definition.hideOverrideTotal\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"overrideTotal\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoice.OverrideTotal' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'overrideTotal')\"\n" +
    "                class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                        id=\"overrideTotal\"\n" +
    "                        name=\"overrideTotal\"\n" +
    "                        data-qe-id=\"bm-billingComponentForm-overrideTotal-currency\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.$overrideTotal\"\n" +
    "                        data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        min=\"0\"\n" +
    "                        max=\"999999999999999.99\"\n" +
    "                        style=\"text-align:right;\"\n" +
    "                        />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"!vm.definition.hideDiscount\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Discount -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.Invoice.Discount' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Invoice.Discount' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-radio-button-group id=\"discountType\"\n" +
    "                                                        name=\"discountType\"\n" +
    "                                                        data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                                        data-ng-model=\"vm.data.$discountType\"\n" +
    "                                                        data-bmp-radio-button-group-options=\"vm.domain.discountOptions\">\n" +
    "                    </bmp-radio-button-group>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Discount Percent -->\n" +
    "                <div ng-if=\"!vm.isDiscountFixed()\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"discountPercent\"\n" +
    "                    data-bmp-control-group-label=\"\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'discountPercent')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                            id=\"discountPercent\"\n" +
    "                            name=\"discountPercent\"\n" +
    "                            data-qe-id=\"bm-billingComponentForm-discountPercent-currency\"\n" +
    "                            class=\"form-control\"\n" +
    "                            data-ng-model=\"vm.data.$discountPercent\"\n" +
    "                            data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                            data-bmp-big-number=\"'p2'\"\n" +
    "                            data-bmp-clear-value=\"0\"\n" +
    "                            bm-format-on-blur=\"\"\n" +
    "                            data-bmp-big-number-range-validator\n" +
    "                            min=\"0\"\n" +
    "                            max=\"100\"\n" +
    "                            style=\"text-align:right;\"\n" +
    "                            />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Discount Amount -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"discountAmount\"\n" +
    "                    data-bmp-control-group-label=\"{{vm.isDiscountFixed() ? '' : 'Core.Captions.PartialInvoice.DiscountAmount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'discountAmount')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                            id=\"discountAmount\"\n" +
    "                            name=\"discountAmount\"\n" +
    "                            data-qe-id=\"bm-billingComponentForm-discountAmount-currency\"\n" +
    "                            class=\"form-control\"\n" +
    "                            data-ng-model=\"vm.data.$discountAmount\"\n" +
    "                            data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                            data-bmp-big-number=\"'c2'\"\n" +
    "                            data-bmp-big-number-range-validator\n" +
    "                            data-bmp-clear-value=\"0\"\n" +
    "                            data-ng-disabled=\"!vm.isDiscountFixed()\"\n" +
    "                            bm-format-on-blur=\"\"\n" +
    "                            min=\"0\"\n" +
    "                            max=\"999999999999999.99\"\n" +
    "                            style=\"text-align:right;\"\n" +
    "                            />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Tax -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"indirectTax\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Invoice.IndirectTax' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'indirectTax')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                        id=\"indirectTax\"\n" +
    "                        name=\"indirectTax\"\n" +
    "                        data-qe-id=\"bm-billingComponentForm-indirectTax-currency\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.indirectTax\"\n" +
    "                        data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        data-ng-disabled=\"true\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        min=\"0\"\n" +
    "                        max=\"999999999999999.99\"\n" +
    "                        style=\"text-align:right;\"\n" +
    "                        />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Invoice Total -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"invoiceTotal\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoice.InvoiceTotal' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceTotal')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                        id=\"invoiceTotal\"\n" +
    "                        name=\"invoiceTotal\"\n" +
    "                        data-qe-id=\"bm-billingComponentForm-invoiceTotal-currency\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.invoiceTotal\"\n" +
    "                        data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        data-ng-disabled=\"true\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        min=\"0\"\n" +
    "                        max=\"999999999999999.99\"\n" +
    "                        style=\"text-align:right;\"\n" +
    "                        />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div bm-if-perm=\"TimeAndBilling.Billing\">\n" +
    "            <hr>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"form-group col-md-12\">\n" +
    "                    <h3>{{'Bluemoon.Billing.Component.TimeEntryAllocationHeader' | translate }}</h3>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"employee\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoice.Selections' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'partialInvoiceAllocationType')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-enum-combo enum=\"partial-invoice-allocation-types\" name=\"partialInvoiceAllocationType\"\n" +
    "                                    ng-model=\"vm.data.partialInvoiceAllocationType\"\n" +
    "                                    required=\"true\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"vm.data.partialInvoiceAllocationType.id === 'ADJUSTMENT' || vm.data.partialInvoiceAllocationType.id === 'PROGRESS'\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"form-group col-md-12\">\n" +
    "                        <h3>{{'Bluemoon.Billing.Component.AllocationAdjustmentHeader' | translate }}</h3>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Engagement -->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"engagement\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoiceSelections.Engagement' | translate }}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.selections, 'engagement')\"\n" +
    "                        class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                        <bmp-select-combo list=\"client-engagements#active\"\n" +
    "                              name=\"engagement\"\n" +
    "                              ng-model=\"vm.data.$engagement\"\n" +
    "                              context=\"vm.data.clientId\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- Activity -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.PartialInvoiceSelections.Activity' -->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"activity\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoiceSelections.Activity' | translate | bmRequiredMark}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.selections, 'activity')\"\n" +
    "                        class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                        <bmp-select-combo list=\"activitiesWithSystem#active\"\n" +
    "                              name=\"activity\"\n" +
    "                              ng-model=\"vm.data.$activity\"\n" +
    "                              filter=\"vm.activityComboFilter()\"\n" +
    "                              required=\"true\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- Staff -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.PartialInvoiceSelections.Employee' -->\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"employee\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.PartialInvoiceSelections.Employee' | translate | bmRequiredMark}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.selections, 'employee')\"\n" +
    "                        class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                        <bmp-select-combo list=\"staffWithSystem#active\"\n" +
    "                                        name=\"employee\"\n" +
    "                                        ng-model=\"vm.data.selections.employee\"\n" +
    "                                        required=\"true\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.data.partialInvoiceAllocationType.id === 'DIRECTTOWIP'\">\n" +
    "                <div class=\"col-md-12\" busy-loader=\"vm.isLoadingDirectToWipGrid\">\n" +
    "                    <div class=\"bmp-wijmo-table-container\">\n" +
    "                        <wj-flex-grid\n" +
    "                            data-qe-id=\"bm-billingComponentForm-directToWip-grid\"\n" +
    "                            control=\"vm.directToWipFlexGrid\"\n" +
    "                            class=\"bento-flex-grid\"\n" +
    "                            items-source=\"vm.timeAndExpenseEntries\"\n" +
    "                            headers-visibility=\"All\"\n" +
    "                            is-read-only=\"true\"\n" +
    "                            selection-mode=\"None\"\n" +
    "                            items-source-changed=\"vm.itemsSourceChanged(s,e)\">\n" +
    "\n" +
    "                            <!-- BEGIN: NEW BENTO SELECTOR -->\n" +
    "                            <wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "                                <div class=\"col-select\">\n" +
    "                                    <i class=\"bento-flex-grid-checkbox\" ng-click=\"$selector.onHeaderCheckBoxChange()\"\n" +
    "                                    ng-class=\"{'bento-icon-checkmark':$selector.headerCheckBoxMode === $selector.CHECKBOX_SELECTED,'bento-icon-minus-plain':$selector.headerCheckBoxMode === $selector.CHECKBOX_INDETERMINATE}\">\n" +
    "                                    </i>\n" +
    "                                </div>\n" +
    "                            </wj-flex-grid-cell-template>\n" +
    "                            <wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "                                <i class=\"bento-flex-grid-checkbox\"\n" +
    "                                    ng-if=\"$item && !$item.$isRowDirty\"\n" +
    "                                    ng-click=\"$item.$selected = !$item.$selected;$selector.onCheckBoxChange({ item: $item, event: $event });\"\n" +
    "                                    ng-class=\"{'bento-icon-checkmark':$item.$selected === true,'disabled':$item.disabled === true,'bento-icon-minus-plain':$item.$selected === $selector.CHECKBOX_INDETERMINATE}\">\n" +
    "                                </i>\n" +
    "                            </wj-flex-grid-cell-template>\n" +
    "                            <!-- END: NEW BENTO SELECTOR -->\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.EntryDate' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"entryDate\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.Client' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"client.name\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.Engagement' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"engagement.code\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"projectScheduleItem.name\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.Activity' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"activity.code\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <wj-flex-grid-column\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.Hours' | translate }}\"\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"hours\"\n" +
    "                                format=\"n2\"\n" +
    "                                align=\"right\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "\n" +
    "                            <!-- WIP -->\n" +
    "                            <wj-flex-grid-column\n" +
    "                                width=\"*\"\n" +
    "                                binding=\"workInProgressAmount\"\n" +
    "                                header=\"{{ 'Core.Captions.TimeAndExpense.Amount' | translate }}\"\n" +
    "                                format=\"c2\"\n" +
    "                                align=\"right\">\n" +
    "                            </wj-flex-grid-column>\n" +
    "                        </wj-flex-grid>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("main/src/billing-selection-and-review/billing-selection-and-review-page.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/billing-selection-and-review/billing-selection-and-review-page.html",
    "<div class=\"container-fluid no-padding-l\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmp-routable-tabset bmp-routable-tabset-tabs=\"vm.tabs\">\n" +
    "                <div ui-view class=\"enter-item-animation\"></div>\n" +
    "            </bmp-routable-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/billing-wip-list/wip-list-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/billing-wip-list/wip-list-directive.html",
    "<h1 class=\"no-top-margin\" data-qe-id=\"header-title\">{{'Bluemoon.Billing.WipByProject.CreateBills' | translate}}</h1>\n" +
    "\n" +
    "<!-- Filter -->\n" +
    "<div class=\"row billing-wip-list-filter\">\n" +
    "    <div ng-form=\"asOfDateForm\">\n" +
    "        <div class=\"col-xs-12 col-sm-6 col-md-6\">\n" +
    "            <invoice-date-selector\n" +
    "                ng-model=\"vm.customParams.datePickerValues\"\n" +
    "                name=\"invoiceDate\"\n" +
    "                invoice-date-selector-label=\"\"\n" +
    "                invoice-date-selector-changed=\"vm.invoiceDateSelectorChanged()\"\n" +
    "                wip-date-selector-changed=\"vm.wipDateSelectorChanged()\"\n" +
    "                dates-are-valid=\"vm.datesAreValid\">\n" +
    "            </invoice-date-selector>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    <div ng-form=\"methodForm\">\n" +
    "        <div class=\"col-xs-12 col-sm-6 col-md-3\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"method\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.Method' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"\"\n" +
    "                class=\"\">\n" +
    "                <bmp-enum-combo\n" +
    "                    enum=\"custom\"\n" +
    "                    name=\"method\"\n" +
    "                    custom-items=\"vm.groupingMethods\"\n" +
    "                    ng-model=\"vm.$selectedMethod\"\n" +
    "                    required=\"true\">\n" +
    "                </bmp-enum-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-3 bmp-btn-group-active\">\n" +
    "        <button\n" +
    "            type=\"button\"\n" +
    "            class=\"btn btn-default btn-toggle pull-right zero-balance-wip-button\"\n" +
    "            ng-model=\"vm.$showZeroBalanceWip\"\n" +
    "            uib-btn-checkbox\n" +
    "            qe-id=\"bm-billingSelection-zeroBalanceWip-button\"\n" +
    "        >\n" +
    "            {{'Bluemoon.Billing.BillingSelection.ZeroBalanceWip' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    " <!--Grid-->\n" +
    " <div class=\"row\">\n" +
    "<!-- make large width 11 to fix a horizontal scrollbar bug w/ wijmo grid-->\n" +
    "    <div ng-if=\"vm.selectedMethod.id === 'PROJECT'\" class=\"col-xs-12\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.projectGridDefinition\"\n" +
    "                bmp-grid-service=\"vm.wipByProjectServiceProxy\"\n" +
    "                bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "        </div>\n" +
    "    <div ng-if=\"vm.selectedMethod.id === 'ENGAGEMENT'\" class=\"col-xs-12\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.engagementGridDefinition\"\n" +
    "                bmp-grid-service=\"vm.wipByEngagementServiceProxy\"\n" +
    "                bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "        </div>\n" +
    "    <div ng-if=\"vm.selectedMethod.id === 'CLIENT'\" class=\"col-xs-12\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.clientGridDefinition\"\n" +
    "                bmp-grid-service=\"vm.wipByClientServiceProxy\"\n" +
    "                bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "        </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/common/invoice-date-selector/invoice-date-selector.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/common/invoice-date-selector/invoice-date-selector.html",
    "<div ng-class=\"{'has-error': vm.error}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div ng-form=\"datePickerForm\">\n" +
    "                <div class=\"col-sm-6\">\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Billing.WipByProject.AsOfDate' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"invoiceDate\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.AsOfDate' | translate | bmRequiredMark}}\"\n" +
    "                        data-bmp-control-group-error=\"\"\n" +
    "                        class=\"\">\n" +
    "                        <bmp-bento-datepicker-wrapper\n" +
    "                            name=\"invoiceDate\"\n" +
    "                            id=\"invoiceDate\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-model=\"vm.value.invoiceDate\"\n" +
    "                            data-ng-change=\"vm.invoiceDateChanged()\">\n" +
    "                        </bmp-bento-datepicker-wrapper>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-sm-6\">\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Billing.WipByProject.WipThroughDate' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"wipThroughDate\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.WipThroughDate' | translate | bmRequiredMark}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.error\"\n" +
    "                        class=\"\">\n" +
    "                        <bmp-bento-datepicker-wrapper\n" +
    "                            name=\"wipThroughDate\"\n" +
    "                            id=\"wipThroughDate\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-model=\"vm.value.wipThroughDate\"\n" +
    "                            data-ng-change=\"vm.wipDateChanged()\">\n" +
    "                        </bmp-bento-datepicker-wrapper>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/common/invoice-date-selector/invoice-due-date-selector.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/common/invoice-date-selector/invoice-due-date-selector.html",
    "<div class=\"row\">\n" +
    "    <div ng-form=\"datePickerForm\">\n" +
    "            <div class=\"col-sm-4\" ng-class=\"{'has-error': vm.invoiceDateError}\">\n" +
    "                <!-- /* i18nextract */'Bluemoon.Billing.WipByProject.AsOfDate' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"invoiceDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.AsOfDate' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"\">\n" +
    "                    <bmp-bento-datepicker-wrapper\n" +
    "                        name=\"invoiceDate\"\n" +
    "                        id=\"invoiceDate\"\n" +
    "                        ng-required=\"true\"\n" +
    "                        ng-model=\"vm.value.invoiceDate\"\n" +
    "                        data-ng-change=\"vm.invoiceDateChanged()\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <!-- /* i18nextract */'Bluemoon.Billing.WipByProject.WipThroughDate' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"wipThroughDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.WipThroughDate' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.wipThroughDateError\"\n" +
    "                    class=\"\">\n" +
    "                    <bmp-bento-datepicker-wrapper\n" +
    "                        name=\"wipThroughDate\"\n" +
    "                        id=\"wipThroughDate\"\n" +
    "                        ng-required=\"true\"\n" +
    "                        ng-model=\"vm.value.wipThroughDate\"\n" +
    "                        data-ng-change=\"vm.wipDateChanged()\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <!-- /* i18nextract */'Core.Captions.Invoice.DateDue' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"dueDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Invoice.DateDue' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.dueDateError\"\n" +
    "                    class=\"\">\n" +
    "                    <bmp-bento-datepicker-wrapper\n" +
    "                        name=\"dueDate\"\n" +
    "                        id=\"dueDate\"\n" +
    "                        ng-required=\"true\"\n" +
    "                        ng-model=\"vm.value.dueDate\"\n" +
    "                        data-ng-change=\"vm.dueDateChanged()\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/common/send-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/common/send-modal.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" aria-label=\"Close dialog\" ng-click=\"vm.cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "\n" +
    "<div class=\"modal-header\">\n" +
    "    <span translate=\"{{vm.options.title}}\"></span>\n" +
    "</div>\n" +
    "\n" +
    "<div bento-busy-loader=\"!vm.queriedStripeService\" bento-busy-loader-size=\"default\" ng-form name=\"sendForm\">\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <h3 class=\"col-md-12\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.FilePreferencesHeader' | translate}}</h3>\n" +
    "    </div>\n" +
    "    <!--<div class=\"row\">\n" +
    "        <div class=\"col-md-4 col-sm-4 col-xs-12\"\n" +
    "            data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"fileFormat\">\n" +
    "            <div data-bento-select>\n" +
    "                <select name=\"fileFormatSelect\" class=\"form-control\" ng-model=\"vm.fileFormatId\">\n" +
    "                    <option ng-repeat=\"fileFormat in vm.fileFormats\" value=\"{{fileFormat.id}}\">{{fileFormat.name}}</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>-->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"bm-billing-{{vm.sendModalName}}-fileFormat\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.FileType' | translate}}\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <bmp-enum-combo enum=\"report-output-types\"\n" +
    "                                name=\"bm-billing-{{vm.sendModalName}}-fileFormat\"\n" +
    "                                ng-model=\"vm.fileFormat\"\n" +
    "                                required=\"true\"\n" +
    "                                value-property=\"id\"\n" +
    "                                label-property=\"name\">\n" +
    "                </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <h3 class=\"col-md-12\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToDestinationHeader' | translate}}</h3>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    data-ng-model=\"vm.useDefaultDeliveryMethod\"\n" +
    "                    data-qe-id=\"bm-billing-{{vm.sendModalName}}-defaultDeliveryMethod-checkbox\"\n" +
    "                    aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.DefaultDeliveryMethod' | translate}}\"\n" +
    "                    aria-labelledby=\"defaultDeliveryMethod\"/>\n" +
    "            <span id=\"defaultDeliveryMethod\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.DefaultDeliveryMethod' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    data-ng-model=\"vm.$downloadToMyComputer\"\n" +
    "                    data-qe-id=\"bm-billing-{{vm.sendModalName}}-downloadToMyComputer-checkbox\"\n" +
    "                    aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.DownloadToMyComputer' | translate}}\"\n" +
    "                    aria-labelledby=\"downloadToMyComputer\"/>\n" +
    "            <span id=\"downloadToMyComputer\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.DownloadToMyComputer' |\n" +
    "                translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-1\"></div>\n" +
    "        <!--spacer-->\n" +
    "        <div data-ng-if=\"vm.hasDisableMergeAndDownloadInvoicesAndStatements\">\n" +
    "            <div class=\"col-md-10 radiobutton\">\n" +
    "                <input autocomplete=\"off\" type=\"radio\" name=\"PDFRadioButtons\"\n" +
    "                    data-ng-model=\"vm.$downloadAsMultipleFiles\"\n" +
    "                    data-ng-value=\"true\"\n" +
    "                    data-ng-change=\"vm.$downloadAsSingleFile=!vm.$downloadAsMultipleFiles\"\n" +
    "                    aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.MultipleFile' |\n" +
    "                    translate}}\"\n" +
    "                    aria-labelledby=\"multipleFile\">\n" +
    "                <span id=\"multipleFile\" style=\"margin-left: 5px;\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.MultipleFile' |\n" +
    "                    translate}}</span>\n" +
    "                <div style=\"margin-top: 15px\">\n" +
    "                    <input autocomplete=\"off\" type=\"radio\" name=\"PDFRadioButtons\"\n" +
    "                        data-ng-model=\"vm.$downloadAsSingleFile\"\n" +
    "                        data-ng-value=\"true\"\n" +
    "                        data-ng-change=\"vm.$downloadAsMultipleFiles=!vm.$downloadAsSingleFile\"\n" +
    "                        aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.SingleFile' |\n" +
    "                        translate}}\"\n" +
    "                        aria-labelledby=\"singleFile\"\n" +
    "                        />\n" +
    "                    <span id=\"singleFile\" style=\"margin-left: 5px;\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.SingleFile' |\n" +
    "                        translate}}</span>\n" +
    "                    <span data-ng-if=\"vm.disableDownloadAsSingleFile() && vm.$downloadToMyComputer\"\n" +
    "                        class=\"bento-icon-question\"\n" +
    "                        data-tooltip-placement=\"top\"\n" +
    "                        data-tooltip-trigger=\"mouseenter\"\n" +
    "                        data-tooltip-append-to-body=\"false\"\n" +
    "                        data-uib-tooltip=\"{{vm.fileTypeToolTip()}}\"\n" +
    "                        style=\"margin-left: 5px;\"\n" +
    "                        tabindex=\"0\">\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-hide=\"!vm.hasClientDocumentsPrivileges\">\n" +
    "        <div class=\"col-md-12 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    data-ng-model=\"vm.$sendToDocuments\"\n" +
    "                    data-qe-id=\"bm-billing-{{vm.sendModalName}}-sendToDocuments-checkbox\"\n" +
    "                    aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToDocuments' | translate}}\"\n" +
    "                    aria-labelledby=\"sendToDocuments\"/>\n" +
    "            <span id=\"sendToDocuments\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToDocuments' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-hide=\"!vm.hasClientAndSendingDocumentsPrivileges()\">\n" +
    "        <div class=\"col-md-1\"></div><!--spacer-->\n" +
    "        <div class=\"col-md-10 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "            data-ng-model=\"vm.$sendToEmail\"\n" +
    "            data-qe-id=\"bm-billing-{{vm.sendModalName}}-sendToEmail-checkbox\"\n" +
    "            aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToEmail' | translate}}\"\n" +
    "            aria-labelledby=\"sendToEmail\"/>\n" +
    "            <span id=\"sendToEmail\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToEmail' | translate}}</span>\n" +
    "            <span\n" +
    "                class=\"bento-icon-question\"\n" +
    "                data-tooltip-placement=\"top\"\n" +
    "                data-tooltip-trigger=\"mouseenter\"\n" +
    "                data-tooltip-append-to-body=\"false\"\n" +
    "                data-qe-id=\"bm-billing-{{vm.sendModalName}}-sendToEmail-checkbox-EmailTooltip\"\n" +
    "                data-uib-tooltip=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.EmailTooltip' | translate }}\"\n" +
    "                style=\"margin-left: 5px;\"\n" +
    "                tabindex=\"0\">\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-hide=\"!vm.isSendToClientCenterVisible()\">\n" +
    "        <div class=\"col-md-1\"></div><!--spacer-->\n" +
    "        <div class=\"col-md-10 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                data-ng-model=\"vm.$sendToClientCenter\"\n" +
    "                data-qe-id=\"bm-billing-{{vm.sendModalName}}-sendToClientCenter-checkbox\"\n" +
    "                aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToClientCenter' | translate}}\"\n" +
    "                aria-labelledby=\"sendToClientCenter\"/>\n" +
    "            <span id=\"sendToClientCenter\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.SendToClientCenter' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-hide=\"!vm.hasClientDocumentsPrivileges\">\n" +
    "        <div class=\"col-md-1\"></div><!--spacer-->\n" +
    "        <div class=\"col-md-10 checkbox\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                    data-ng-model=\"vm.$openInDocuments\"\n" +
    "                    data-qe-id=\"bm-billing-{{vm.sendModalName}}-openInDocuments-checkbox\"\n" +
    "                    aria-label=\"{{'Bluemoon.Billing.ReviewInvoices.SendModal.OpenInDocuments' | translate}}\"\n" +
    "                    aria-labelledby=\"openInDocuments\"/>\n" +
    "            <span id=\"openInDocuments\">{{'Bluemoon.Billing.ReviewInvoices.SendModal.OpenInDocuments' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div><!-- end of sendForm -->\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button\n" +
    "        type=\"button\"\n" +
    "        data-qe-id=\"bm-sendForm-save-button\"\n" +
    "        class=\"btn btn-primary\"\n" +
    "        ng-click=\"vm.save(false)\"\n" +
    "        ng-disabled=\"vm.sendButtonDisabled()\"\n" +
    "        translate>Bluemoon.Billing.ReviewInvoices.SendModal.SendButton</button>\n" +
    "\n" +
    "    <button\n" +
    "        type=\"button\"\n" +
    "        data-qe-id=\"bm-sendForm-cancel-button\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        ng-click=\"vm.cancel()\"\n" +
    "        translate>Bluemoon.Practice.Common.Buttons.Cancel</button>\n" +
    "</div>\n" +
    "<file-merger></file-merger>\n" +
    "");
}]);

angular.module("main/src/create-statements/create-statements-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/create-statements/create-statements-directive.html",
    "<div bento-busy-loader=\"vm.loaderBusy\" class=\"billing-create-statement\">\n" +
    "    <h1 class=\"no-top-margin\"\n" +
    "    data-qe-id=\"header-title\">{{'Bluemoon.Billing.CreateStatements.HeaderTitle' | translate}}</h1>\n" +
    "    <div ng-form=\"statementsForm\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-8\">\n" +
    "                <bmp-date-range-selector\n" +
    "                    name=\"bm-createStatements-dateRangeSelector\"\n" +
    "                    data-qe-id=\"bm-createStatements-dateRangeSelector\"\n" +
    "                    bmp-date-range-selector-label=\"{{'Bluemoon.Billing.CreateStatements.IncludeActivityFrom' | translate}}\"\n" +
    "                    bmp-date-range-selector-options=\"vm.activityDateRangeSelectorOptions\"\n" +
    "                    bmp-date-range-selector-options-default=\"MONTH\"\n" +
    "                    bmp-date-range-selector-changed=\"vm.activityDateRangeChanged({dateRangeValueId: dateRangeId, startDate: startDate, endDate: endDate})\">\n" +
    "                </bmp-date-range-selector>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"formatOverride\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.CreateStatements.FormatOverride' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\">\n" +
    "                    <bmp-select-combo\n" +
    "                        list=\"report-definition#statement\"\n" +
    "                        name=\"report-definition#statement\"\n" +
    "                        list-style=\"basic\"\n" +
    "                        data-qe-id=\"bm-statementsForm-formatOverride-text\"\n" +
    "                        ng-model=\"vm.formatOverride\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-8 col-sm-5 bmp-btn-group-active\">\n" +
    "                <button type=\"button\" class=\"btn btn-default btn-toggle pull-right clients-with-invoices-in-range-button\"\n" +
    "                ng-model=\"vm.$showClientsWithInvoicesInRange\"\n" +
    "                qe-id=\"bm-createStatements-ClientsWithInvoices-button\"\n" +
    "                uib-btn-checkbox>\n" +
    "                {{'Bluemoon.Billing.CreateStatements.ClientsWithInvoicesInRange' | translate}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Grid -->\n" +
    "    <div class=\"row\">\n" +
    "        <!-- make large width 11 to fix a horizontal scrollbar bug w/ wijmo grid-->\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                    bmp-grid-service=\"vm.statementSummaryServiceProxy\"\n" +
    "                    bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/detail-billing/billable/detail-billing-billable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/billable/detail-billing-billable.html",
    "<bmp-grid ng-if=\"vm.service\" bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-description-row.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-description-row.html",
    "<div ng-form name=\"descriptionRowForm\">\n" +
    "    <div bento-busy-loader=\"vm.isLoadingData()\" bento-busy-loader-size=\"default\">\n" +
    "\n" +
    "        <br>\n" +
    "        <!-- Description Row -->\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"description\" data-bmp-control-group-field-id=\"description\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.Compose.Description' | translate }}\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"description\" data-qe-id=\"bm-descriptionRowForm-description-textbox\"\n" +
    "                    type=\"text\" class=\"form-control input-lg\" bm-format-on-blur=\"\"\n" +
    "                    data-ng-model=\"vm.model.description\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Amount -->\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"descriptionAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Amount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(vm.model.amount, 'descriptionAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"descriptionAmount\"\n" +
    "                    data-qe-id=\"bm-descriptionRowForm-descriptionAmount-number\" type=\"text\"\n" +
    "                    class=\"form-control input-lg\" data-ng-model=\"vm.model.amount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"vm.recalculateFor('descriptionAmount', '$.data.descriptionAmount')\"\n" +
    "                    bm-format-on-blur=\"\" data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.AccountsReceivable.Amount\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <br>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-fixed-fee.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-fixed-fee.html",
    "<div ng-form name=\"fixedFeeForm\">\n" +
    "    <div class=\"row\">\n" +
    "        <br/>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                          bmp-grid-service=\"vm.fixedFeeService\"\n" +
    "                          bmp-grid-before-load=\"vm.beforeLoad($sender)\"></bmp-grid>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-flat-amount.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-flat-amount.html",
    "<div ng-form name=\"flatAmountForm\">\n" +
    "    <div bento-busy-loader=\"vm.isLoadingData()\" bento-busy-loader-size=\"default\">\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <br/>\n" +
    "            <label>\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"BILLINGADJUSTMENT\"\n" +
    "                    name=\"flatAmountOptions_BILLINGADJUSTMENT\"\n" +
    "                    data-qe-id=\"flatAmountOptions_BILLINGADJUSTMENT\"\n" +
    "                    ng-model=\"vm.entryType\"\n" +
    "                    data-ng-change=\"vm.entryTypeChanged()\"\n" +
    "                    bmp-default-focus\n" +
    "                    />\n" +
    "                {{'Bluemoon.Billing.DetailBilling.Compose.AdjustmentEntry' | translate}}\n" +
    "            </label>\n" +
    "            <i class=\"bento-icon-question\"\n" +
    "            uib-tooltip=\"{{ 'Bluemoon.Billing.DetailBilling.Compose.AdjustmentDescription' | translate }}\"\n" +
    "            tooltip-trigger=\"mouseenter\"\n" +
    "            tooltip-placement=\"right\"\n" +
    "            tooltip-append-to-body=\"true\"></i><br/>\n" +
    "            <label>\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"PROGRESSBILLING\"\n" +
    "                    name=\"flatAmountOptions_PROGRESSBILLING\"\n" +
    "                    data-qe-id=\"flatAmountOptions_PROGRESSBILLING\"\n" +
    "                    ng-model=\"vm.entryType\"\n" +
    "                    data-ng-change=\"vm.entryTypeChanged()\"\n" +
    "                    />\n" +
    "                {{'Bluemoon.Billing.DetailBilling.Compose.ProgressEntry' | translate}}\n" +
    "            </label>\n" +
    "            <i class=\"bento-icon-question\"\n" +
    "            uib-tooltip=\"{{ 'Bluemoon.Billing.DetailBilling.Compose.ProgressDescription' | translate }}\"\n" +
    "            tooltip-trigger=\"mouseenter\"\n" +
    "            tooltip-placement=\"right\"\n" +
    "            tooltip-append-to-body=\"true\"></i><br/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Amount -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"amount\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Amount' | translate }}\"\n" +
    "        class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"amount\"\n" +
    "            data-qe-id=\"bm-flatAmountForm-amount-textbox\"\n" +
    "            type=\"text\"\n" +
    "            class=\"form-control input-lg\"\n" +
    "            bm-format-on-blur=\"\"\n" +
    "            data-bmp-big-number=\"'c2'\"\n" +
    "            data-ng-model=\"vm.data.detailModel.amounts.billedAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Service/Engagement -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"engagement\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Engagement' | translate }}\"\n" +
    "        class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"client-engagements#active\"\n" +
    "                name=\"engagement\"\n" +
    "                ng-required=\"vm.requireServices\"\n" +
    "                ng-model=\"vm.data.detailModel.timeAndExpense.$engagement\"\n" +
    "                context=\"vm.client.id\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Project -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"projectScheduleItem\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"project-views#frpTimeAndExpense\"\n" +
    "                name=\"projectScheduleItem\"\n" +
    "                ng-required=\"vm.requireProjects\"\n" +
    "                ng-model=\"vm.data.detailModel.timeAndExpense.$projectScheduleItem\"\n" +
    "                filter=\"vm.projectComboFilter()\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Activity -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"activity\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Activity' | translate }}\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"activities#active#billable\"\n" +
    "                name=\"activity\"\n" +
    "                ng-model=\"vm.data.detailModel.timeAndExpense.activity\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Staff/Employee -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"staff\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Employee' | translate }}\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\"\n" +
    "                name=\"staff\"\n" +
    "                ng-model=\"vm.data.detailModel.timeAndExpense.employee\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-invoice-amounts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-invoice-amounts.html",
    "<div ng-form name=\"quickBillForm\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Selected Amount -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"workInProgressAmount\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.QuickBill.SelectedWipAmount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.errorFor(vm.invoiceTotalAmounts, 'workInProgressAmount')\"\n" +
    "                    class=\"col-xs-6\">\n" +
    "                <input autocomplete=\"off\" name=\"workInProgressAmount\"\n" +
    "                        data-qe-id=\"bm-quickBillForm-workInProgressAmount-number\"\n" +
    "                        type=\"text\"\n" +
    "                        readonly class=\"form-control input-lg\"\n" +
    "                        data-ng-model=\"vm.invoiceTotalAmounts.workInProgressAmount\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-control-group-field=\"Bluemoon.Billing.DetailBilling.QuickBill.SelectedWipAmount\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <!--Progress Amount-->\n" +
    "            <div ng-if=\"vm.invoiceTotalAmounts.progressAmount\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"inProgressAmount\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.QuickBill.ProgressAmount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.errorFor(vm.invoiceTotalAmounts, 'carryoverAmount')\"\n" +
    "                    class=\"col-xs-6\">\n" +
    "                <input autocomplete=\"off\" name=\"inProgressAmount\"\n" +
    "                        data-qe-id=\"bm-quickBillForm-inProgressAmount-number\"\n" +
    "                        type=\"text\"\n" +
    "                        readonly class=\"form-control input-lg\"\n" +
    "                        data-ng-model=\"vm.invoiceTotalAmounts.progressAmount\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-control-group-field=\"Bluemoon.Billing.DetailBilling.QuickBill.ProgressAmount\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"vm.grouping.grouping1\">\n" +
    "        <!-- Grouping 1 -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"grouping1\"\n" +
    "                data-bmp-control-group-label=\"{{ vm.groupByDescriptionName(1) }}\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <bm-practice-billing-compose-froala-field data-qe-id=\"bm-quickBillForm-grouping1-textbox\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    editors= \"vm.editors\"\n" +
    "                    object=\"vm.grouping.grouping1\"\n" +
    "                    field=\"name\"\n" +
    "                    is-group-one=\"true\"\n" +
    "                    ng-readonly=\"vm.grouping.grouping2\"\n" +
    "                    is-read-only=\"vm.grouping.grouping2\"\n" +
    "                    field-type=\"string\"\n" +
    "                    force-focus=\"true\"></bm-practice-billing-compose-froala-field>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.grouping.grouping2\">\n" +
    "        <!-- Grouping 2 -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"grouping2\"\n" +
    "                data-bmp-control-group-label=\"{{ vm.groupByDescriptionName(2) }}\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <bm-practice-billing-compose-froala-field data-qe-id=\"bm-quickBillForm-grouping2-textbox\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    editors= \"vm.editors\"\n" +
    "                    object=\"vm.grouping.grouping2\"\n" +
    "                    field=\"name\"\n" +
    "                    is-group-one=\"true\"\n" +
    "                    ng-readonly=\"vm.grouping.grouping3\"\n" +
    "                    is-read-only=\"vm.grouping.grouping3\"\n" +
    "                    field-type=\"string\"\n" +
    "                    force-focus=\"true\"></bm-practice-billing-compose-froala-field>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.grouping.grouping3\">\n" +
    "        <!-- Grouping 3 -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"grouping3\"\n" +
    "                data-bmp-control-group-label=\"{{ vm.groupByDescriptionName(3) }}\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <bm-practice-billing-compose-froala-field data-qe-id=\"bm-quickBillForm-grouping3-textbox\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    editors= \"vm.editors\"\n" +
    "                    object=\"vm.grouping.grouping3\"\n" +
    "                    field=\"name\"\n" +
    "                    is-group-one=\"true\"\n" +
    "                    field-type=\"string\"\n" +
    "                    force-focus=\"true\"></bm-practice-billing-compose-froala-field>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Billed Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"billedAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.BilledAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(vm.invoiceTotalAmounts, 'billedAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"billedAmount\"\n" +
    "                    data-qe-id=\"bm-quickBillForm-billedAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.invoiceTotalAmounts.billedAmount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"vm.recalculateFor('billedAmount', '$.data.billedAmount')\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.BilledAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Adjusted Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"adjustmentAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.AdjustmentAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(vm.invoiceTotalAmounts, 'adjustmentAmount')\"\n" +
    "                append-to-parent=\"\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"adjustmentAmount\"\n" +
    "                    data-qe-id=\"bm-quickBillForm-adjustmentAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.invoiceTotalAmounts.adjustmentAmount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"vm.recalculateFor('adjustmentAmount', '$.data.adjustmentAmount')\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.AdjustmentAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Carryover Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"carryoverAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.CarryoverAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(vm.invoiceTotalAmounts, 'carryoverAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"carryoverAmount\"\n" +
    "                     data-qe-id=\"bm-quickBillForm-carryoverAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    disabled class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.carryoverAmount\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.CarryoverAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-time-and-expenses.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-time-and-expenses.html",
    "<p style=\"height: 40px; display: table-cell; vertical-align: bottom;\" ng-bind-html=\"vm.getHeaderString()\"></p>\n" +
    "<bmp-grid ng-if=\"vm.service\" bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\" bmp-grid-before-load=\"vm.beforeLoad($sender)\"></bmp-grid>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/add/db-compose-add-to-invoice-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/add/db-compose-add-to-invoice-options.html",
    "<div ng-form name=\"invoiceOptionsForm\">\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <br/>\n" +
    "            <label style=\"text-indent:10px\">\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"TIMEANDEXPENSE\"\n" +
    "                    name=\"addToInvoiceOptions_TIMEANDEXPENSE\"\n" +
    "                    data-qe-id=\"addToInvoiceOptions_TIMEANDEXPENSE\"\n" +
    "                    ng-model=\"vm.selectedOption\"\n" +
    "                    />\n" +
    "                {{'Bluemoon.Billing.DetailBilling.Compose.TimeAndExpense' | translate}}\n" +
    "            </label><br/>\n" +
    "            <div ng-if=\"vm.billByClient\">\n" +
    "                <label style=\"text-indent:10px\">\n" +
    "                    <input type=\"radio\"\n" +
    "                        value=\"FIXEDFEE\"\n" +
    "                        name=\"addToInvoiceOptions_FIXEDFEE\"\n" +
    "                        data-qe-id=\"addToInvoiceOptions_FIXEDFEE\"\n" +
    "                        data-ng-disabled=\"vm.existingInvoice || vm.existingBilledAmount\"\n" +
    "                        ng-model=\"vm.selectedOption\"\n" +
    "                        />\n" +
    "                    {{'Bluemoon.Billing.Navigation.FixedFee' | translate}}\n" +
    "                </label>\n" +
    "                <i class=\"bento-icon-question\"\n" +
    "                ng-if=\"vm.existingInvoice || vm.existingBilledAmount\"\n" +
    "                uib-tooltip=\"{{ 'Bluemoon.Billing.DetailBilling.Compose.FixedFeeDisabledDescription' | translate }}\"\n" +
    "                tooltip-trigger=\"mouseenter\"\n" +
    "                tooltip-placement=\"right\"\n" +
    "                tooltip-append-to-body=\"true\"></i>\n" +
    "            </div>\n" +
    "            <label style=\"text-indent:10px\">\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"FLATAMOUNT\"\n" +
    "                    name=\"addToInvoiceOptions_FLATAMOUNT\"\n" +
    "                    data-qe-id=\"addToInvoiceOptions_FLATAMOUNT\"\n" +
    "                    ng-model=\"vm.selectedOption\"\n" +
    "                    />\n" +
    "                {{'Bluemoon.Billing.DetailBilling.Compose.FlatAmount' | translate}}\n" +
    "            </label>\n" +
    "            <div ng-if=\"vm.detailedDescriptionRow\">\n" +
    "                <label style=\"text-indent:10px\">\n" +
    "                    <input type=\"radio\"\n" +
    "                        value=\"DETAILEDDESCRIPTIONROW\"\n" +
    "                        name=\"addToInvoiceOptions_DETAILEDDESCRIPTIONROW\"\n" +
    "                        data-qe-id=\"addToInvoiceOptions_DETAILEDDESCRIPTIONROW\"\n" +
    "                        data-ng-disabled=\"!vm.existingBilledAmount\"\n" +
    "                        ng-model=\"vm.selectedOption\"\n" +
    "                        />\n" +
    "                        {{'Bluemoon.Billing.DetailBilling.Compose.DetailedDescriptionRow' | translate}}\n" +
    "                </label>\n" +
    "                <i class=\"bento-icon-question\"\n" +
    "                ng-if=\"!vm.existingBilledAmount\"\n" +
    "                uib-tooltip=\"{{ 'Bluemoon.Billing.DetailBilling.Compose.DetailedDescriptionRowDisabledDescription' | translate }}\"\n" +
    "                tooltip-trigger=\"mouseenter\"\n" +
    "                tooltip-placement=\"right\"\n" +
    "                tooltip-append-to-body=\"true\"></i>\n" +
    "            </div><br/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/db-compose-froala-field.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/db-compose-froala-field.html",
    "<div ng-if=\"vm.showToolbar()\" class=\"dbc-froala-floating-buttons\" style=\"margin-left: -{{vm.options.dbcButtons.length * 33}}px; margin-top:-6px;\">\n" +
    "    <button ng-repeat=\"buttonKey in vm.options.dbcButtons\" ng-click=\"vm.options.getButtonDefinition(buttonKey).callback()\" tabindex=\"-1\" type=\"button\" class=\"fr-bttn\" title=\"{{vm.options.getButtonDefinition(buttonKey).title}}\">\n" +
    "        <i class=\"{{vm.options.getButtonDefinition(buttonKey).icon.value}}\"></i>\n" +
    "    </button>\n" +
    "</div>\n" +
    "<div ng-if=\"vm.froalaInstantiated && !vm.options.$destroyed\" ng-show=\"vm.isEditing\" froala=\"vm.options\" ng-model=\"vm.data\"></div>\n" +
    "<div ng-if=\"!vm.isReadOnly\" class=\"froala-element froala-view dbc-froala-fake-field\" ng-show=\"!vm.isEditing\" ng-click=\"vm.clicked()\" ng-bind-html=\"vm.dataSafe\"\n" +
    "     tabindex=\"0\" ng-focus=\"vm.clicked()\"></div>\n" +
    "<div ng-if=\"vm.isReadOnly\" class=\"dbc-froala-fake-field-read-only\" ng-bind-html=\"vm.dataSafe\"></div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/db-compose-invoice-error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/db-compose-invoice-error.html",
    "<div class=\"modal-body modal-confirm-body\">\n" +
    "	<span class=\"modal-confirm-message display-inline-block\" translate=\"Bluemoon.Billing.DetailBilling.Compose.Invoice.Error\"></span>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" translate ng-click=\"cancel()\" data-qe-id=\"bm-detailBillingCompose-error-modal-ok-button\">Bluemoon.Practice.Common.Actions.Ok</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/db-compose-totals-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/db-compose-totals-summary.html",
    "<div class=\"bmp-summary-blocks dbc-summary-totals\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-4\">{{'Bluemoon.Billing.DetailBilling.Compose.Summary.TotalBilledAmount' | translate }}<p>{{ vm.getFormattedBilledAmount() }}</p></div>\n" +
    "        <div class=\"col-xs-4\">{{'Bluemoon.Billing.DetailBilling.Compose.Summary.ComposeTotal' | translate }}<p>{{ vm.getFormattedComposeTotal() }}</p></div>\n" +
    "        <div class=\"col-xs-4\" ng-class=\"{ 'dbc-summary-totals-not-match': vm.hasDifference() }\">{{'Bluemoon.Billing.DetailBilling.Compose.Summary.Difference' | translate }} <p class=\"dbc-summary-totals-amount\">{{ vm.getFormattedDifference() }}</p></div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/detail-billing/compose/db-compose-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/db-compose-view.html",
    "<div class=\"froala-editor f-basic\" style=\"z-index: 2000;\">\n" +
    "    <div class=\"bttn-wrapper\" id=\"bttn-wrapper-1\" ng-click=\"vm.toolbarButtonClicked($event)\">\n" +
    "        <button tabindex=\"-1\" type=\"button\" class=\"fr-bttn\" title=\"{{'Bluemoon.Froala.Bold' | translate}}\" data-cmd=\"bold\"><i class=\"fa fa-bold\"></i></button>\n" +
    "        <button tabindex=\"-1\" type=\"button\" class=\"fr-bttn\" title=\"{{'Bluemoon.Froala.Italic' | translate}}\" data-cmd=\"italic\"><i class=\"fa fa-italic\"></i></button>\n" +
    "        <button tabindex=\"-1\" type=\"button\" class=\"fr-bttn\" title=\"{{'Bluemoon.Froala.Underline' | translate}}\" data-cmd=\"underline\"><i class=\"fa fa-underline\"></i></button>\n" +
    "        <div class=\"fr-bttn fr-dropdown \">\n" +
    "            <button tabindex=\"-1\" type=\"button\" data-name=\"fontSize\" class=\"fr-trigger\" title=\"{{'Bluemoon.Froala.FontSize' | translate}}\"><i class=\"fa fa-text-height\"></i></button>\n" +
    "            <ul class=\"fr-dropdown-menu f-font-sizes\">\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"6pt\"><button><span>6</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"7pt\"><button><span>7</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"8pt\"><button><span>8</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"9pt\"><button><span>9</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"10pt\"><button><span>10</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"11pt\"><button><span>11</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"12pt\"><button><span>12</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"13pt\"><button><span>13</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"14pt\"><button><span>14</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"15pt\"><button><span>15</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"16pt\"><button><span>16</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"17pt\"><button><span>17</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"18pt\"><button><span>18</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"19pt\"><button><span>19</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"20pt\"><button><span>20</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"21pt\"><button><span>21</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"22pt\"><button><span>22</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"23pt\"><button><span>23</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"24pt\"><button><span>24</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"25pt\"><button><span>25</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"26pt\"><button><span>26</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"27pt\"><button><span>27</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"28pt\"><button><span>28</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"29pt\"><button><span>29</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"30pt\"><button><span>30</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"31pt\"><button><span>31</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"32pt\"><button><span>32</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"33pt\"><button><span>33</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"34pt\"><button><span>34</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"35pt\"><button><span>35</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"36pt\"><button><span>36</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"37pt\"><button><span>37</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"38pt\"><button><span>38</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"39pt\"><button><span>39</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"40pt\"><button><span>40</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"41pt\"><button><span>41</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"42pt\"><button><span>42</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"43pt\"><button><span>43</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"44pt\"><button><span>44</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"45pt\"><button><span>45</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"46pt\"><button><span>46</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"47pt\"><button><span>47</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"48pt\"><button><span>48</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"49pt\"><button><span>49</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"50pt\"><button><span>50</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"51pt\"><button><span>51</span></button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontSize\" data-val=\"52pt\"><button><span>52</span></button></li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <div class=\"fr-bttn fr-dropdown fr-family\">\n" +
    "            <button tabindex=\"-1\" type=\"button\" data-name=\"fontFamily\" class=\"fr-trigger\" title=\"{{'Bluemoon.Froala.FontFamily' | translate}}\"><i class=\"fa fa-font\"></i></button>\n" +
    "            <ul class=\"fr-dropdown-menu\">\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Arial,Helvetica\"><button data-text=\"true\" title=\"Arial, Helvetica\" style=\"font-family: Arial,Helvetica;\">Arial, Helvetica</button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Courier,Courier New\"><button data-text=\"true\" title=\"Courier, Courier New\" style=\"font-family: Courier,Courier New;\">Courier, Courier New</button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Georgia\"><button data-text=\"true\" title=\"Georgia\" style=\"font-family: Georgia;\">Georgia</button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Times New Roman,Times\"><button data-text=\"true\" title=\"Times New Roman,Times\" style=\"font-family: Times New Roman,Times;\">Times New Roman,Times</button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Trebuchet MS\"><button data-text=\"true\" title=\"Trebuchet MS\" style=\"font-family: Trebuchet MS;\">Trebuchet MS</button></li>\n" +
    "                    <li class=\"dbc-custom-fr-button\" data-cmd=\"fontFamily\" data-val=\"Verdana, Geneva\"><button data-text=\"true\" title=\"Verdana,Geneva\" style=\"font-family: Verdana, Geneva;\">Verdana,Geneva</button></li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <div class=\"fr-bttn fr-dropdown fr-color-picker\"><button tabindex=\"-1\" type=\"button\" data-name=\"color\"\n" +
    "                class=\"fr-trigger\" title=\"{{'Bluemoon.Froala.Color' | translate}}\"><i class=\"fa fa-tint\"></i></button>\n" +
    "            <div class=\"fr-dropdown-menu\">\n" +
    "                <div class=\"fr-color-set fr-foreColor\" style=\"display: block\">\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#61BD6D\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #61BD6D;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#1ABC9C\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #1ABC9C;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#54ACD2\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #54ACD2;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#2C82C9\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #2C82C9;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#9365B8\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #9365B8;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#475577\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #475577;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#CCCCCC\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #CCCCCC;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#41A85F\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #41A85F;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#00A885\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #00A885;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#3D8EB9\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #3D8EB9;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#2969B0\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #2969B0;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#553982\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #553982;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#28324E\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #28324E;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#000000\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #000000;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#F7DA64\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #F7DA64;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FBA026\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #FBA026;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#EB6B56\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #EB6B56;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#E25041\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #E25041;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#A38F84\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #A38F84;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#EFEFEF\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #EFEFEF;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FFFFFF\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #FFFFFF;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FAC51C\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #FAC51C;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#F37934\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #F37934;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#D14841\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #D14841;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#B8312F\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #B8312F;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#7C706B\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #7C706B;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#D1D5D8\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #D1D5D8;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#123456\" data-cmd=\"color\" data-param=\"foreColor\" style=\"background: #FFF;\"><i class=\"fa fa-eraser\"></i></button>\n" +
    "                    <hr>\n" +
    "                </div>\n" +
    "                <div class=\"fr-color-set fr-backColor\" style=\"display: none\">\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#61BD6D\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #61BD6D;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#1ABC9C\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #1ABC9C;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#54ACD2\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #54ACD2;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#2C82C9\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #2C82C9;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#9365B8\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #9365B8;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#475577\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #475577;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#CCCCCC\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #CCCCCC;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#41A85F\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #41A85F;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#00A885\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #00A885;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#3D8EB9\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #3D8EB9;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#2969B0\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #2969B0;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#553982\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #553982;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#28324E\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #28324E;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#000000\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #000000;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#F7DA64\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #F7DA64;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FBA026\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #FBA026;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#EB6B56\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #EB6B56;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#E25041\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #E25041;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#A38F84\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #A38F84;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#EFEFEF\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #EFEFEF;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FFFFFF\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #FFFFFF;\">&nbsp;</button>\n" +
    "                    <hr>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#FAC51C\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #FAC51C;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#F37934\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #F37934;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#D14841\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #D14841;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#B8312F\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #B8312F;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#7C706B\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #7C706B;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#D1D5D8\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #D1D5D8;\">&nbsp;</button>\n" +
    "                    <button type=\"button\" class=\"fr-color-bttn\" data-val=\"#123456\" data-cmd=\"color\" data-param=\"backColor\" style=\"background: #FFF;\"><i class=\"fa fa-eraser\"></i></button>\n" +
    "                    <hr>\n" +
    "                </div>\n" +
    "                <p><span class=\"fr-choose-color active\" data-text=\"true\" data-param=\"foreColor\"\n" +
    "                        style=\"width: 50%;\">Text</span><span class=\"fr-choose-color \" data-text=\"true\"\n" +
    "                        data-param=\"backColor\" style=\"width: 50%;\">Background</span></p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <button ng-if=\"vm.hasCurrentdevelopmentFRP\" tabindex=\"0\" class=\"fr-bttn\" title=\"Bulleted List\" data-cmd=\"insertUnorderedList\" aria-label=\"Bulleted List\"><i class=\"fa fa-list-ul\"></i></button>\n" +
    "        <button ng-if=\"vm.hasCurrentdevelopmentFRP\" tabindex=\"0\" class=\"fr-bttn\" title=\"Numbered List\" data-cmd=\"insertOrderedList\" aria-label=\"Numbered List\"><i class=\"fa fa-list-ol\"></i></button>\n" +
    "        <div class=\"fr-bttn fr-dropdown \"><button tabindex=\"-1\" type=\"button\" data-name=\"align\" class=\"fr-trigger\"\n" +
    "                title=\"{{'Bluemoon.Froala.Alignment' | translate}}\"><i class=\"fa fa-align-left\"></i></button>\n" +
    "            <ul class=\"fr-dropdown-menu f-align\">\n" +
    "                <li class=\"dbc-custom-fr-button\" data-cmd=\"align\" data-val=\"justifyLeft\" title=\"{{'Bluemoon.Froala.AlignLeft' | translate}}\"><button><i class=\"fa fa-align-left\"></i></button></li>\n" +
    "                <li class=\"dbc-custom-fr-button\" data-cmd=\"align\" data-val=\"justifyCenter\" title=\"{{'Bluemoon.Froala.AlignCenter' | translate}}\"><button><i class=\"fa fa-align-center\"></i></button></li>\n" +
    "                <li class=\"dbc-custom-fr-button\" data-cmd=\"align\" data-val=\"justifyRight\" title=\"{{'Bluemoon.Froala.AlignRight' | translate}}\"><button><i class=\"fa fa-align-right\"></i></button></li>\n" +
    "                <li class=\"dbc-custom-fr-button\" data-cmd=\"align\" data-val=\"justifyFull\" title=\"{{'Bluemoon.Froala.Justify' | translate}}\"><button><i class=\"fa fa-align-justify\"></i></button></li>\n" +
    "            </ul>\n" +
    "        </div><button tabindex=\"-1\" type=\"button\" class=\"fr-bttn\" title=\"{{'Bluemoon.Froala.Undo' | translate}}\"\n" +
    "            data-cmd=\"undo\"><i class=\"fa fa-undo\"></i></button><button tabindex=\"-1\" type=\"button\" class=\"fr-bttn\"\n" +
    "            title=\"{{'Bluemoon.Froala.Redo' | translate}}\" data-cmd=\"redo\"><i class=\"fa fa-repeat\"></i></button>\n" +
    "\n" +
    "<span class=\"f-sep\"></span>\n" +
    "<div class=\"fr-bttn fr-dropdown\">\n" +
    "    <button tabindex=\"-1\" type=\"button\" data-name=\"reportOptions\" class=\"fr-trigger\" title=\"{{'Bluemoon.Billing.DetailBilling.Compose.ToolbarSettings' | translate}}\">\n" +
    "        <i class=\"fa fa-sliders\"></i>\n" +
    "    </button>\n" +
    "    <ul class=\"fr-dropdown-menu\">\n" +
    "            <li class=\"dbc-custom-fr-button\" ng-click=\"vm.toggleEnableGroupTotals()\">\n" +
    "                <button type=\"button\"><i ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined:'bento-icon-checkbox'} [vm.enableGroupTotals]\"></i>{{'Bluemoon.Billing.DetailBilling.Compose.EnableGroupTotalsButton' | translate}}</button>\n" +
    "            </li>\n" +
    "            <li class=\"dbc-custom-fr-button\" ng-click=\"vm.toggleEnableDetail()\">\n" +
    "                <button type=\"button\"><i ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined:'bento-icon-checkbox'} [vm.data.reportParams.enableDetail]\"></i>{{'Bluemoon.Billing.DetailBilling.Compose.EnableDetailButton' | translate}}</button>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "</div>\n" +
    "<div class=\"fr-bttn fr-dropdown\">\n" +
    "    <button tabindex=\"-1\" type=\"button\" class=\"fr-trigger\" title=\"{{'Bluemoon.Practice.StandardText.InsertTooltip' | translate}}\" data-name=\"standardTextInsert\">\n" +
    "        <i class=\"bento-icon-paste\"></i>\n" +
    "    </button>\n" +
    "    <ul class=\"fr-dropdown-menu f-standard-text\">\n" +
    "        <li class=\"dbc-custom-fr-button\" data-ng-repeat=\"standardTextItem in vm.standardTextItems\" data-name=\"standardTextInsert{{$index}}\" ng-click=\"vm.insertStandardText(standardTextItem)\"><button>{{standardTextItem.code}}</button></li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<button tabindex=\"-1\" type=\"button\" class=\"fr-bttn dbc-custom-fr-button\" title=\"{{'Bluemoon.Billing.DetailBilling.Compose.RebuildComposeData' | translate}}\" ng-disabled=\"!vm.rebuildComposeDataEnabled()\" ng-click=\"vm.rebuildComposeDataClicked()\"><i class=\"fa fa-refresh\"></i></button>\n" +
    "</div></div>\n" +
    "\n" +
    "<div ng-if=\"!vm.invoiceHasBilledAmounts()\" class=\"detail-billing-compose-directions row\">\n" +
    "    <div class=\"main-icon\">\n" +
    "        <span class=\"bento-icon-coins\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"h1\">{{ 'Bluemoon.Billing.DetailBilling.Compose.DirectionsText1' | translate }}</div>\n" +
    "    <div class=\"h3\">{{ 'Bluemoon.Billing.DetailBilling.Compose.DirectionsText2' | translate }}</div>\n" +
    "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addToInvoice()\">{{ 'Bluemoon.Billing.DetailBilling.Compose.AddToInvoice' | translate }}</button>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"vm.invoiceHasBilledAmounts() && vm.layout\" class=\"dbc-billing-compose-froala\"><div class=\"billing-compose-wrapper\"><div class=\"billing-compose-page\">\n" +
    "    <bm-compose-layout-component layout=\"vm.layout\" data=\"vm.data\" editors=\"vm.editors\"></bm-compose-layout-component>\n" +
    "    <div id=\"dbc-add-to-invoice-floating-button\">\n" +
    "        <a ng-click=\"vm.addToInvoice()\">\n" +
    "            <i class=\"bento-icon-add\"></i> {{ 'Bluemoon.Billing.DetailBilling.Compose.AddToInvoice' | translate }}\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div></div></div>\n" +
    "\n" +
    "<div><span class=\"fr-placeholder\" unselectable=\"on\"></span></div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/db-compose.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/db-compose.html",
    "<div bento-busy-loader=\"vm.isBusyLoaderVisible()\">\n" +
    "    <bm-practice-billing-compose-view data=\"vm.composeData\" editors=\"vm.editors\" layout=\"vm.layout\" invoice=\"vm.invoice\" wip-through-date=\"vm.wipThroughDate\" bill-by-type=\"vm.billByType\" current-selection-client-ids=\"vm.currentSelectionClientIds\"/>\n" +
    "</div>\n" +
    "<div ng-if=\"vm.allowIndependentInvoiceComposeRows && !vm.isBusyLoaderVisible() && vm.layout && vm.composeData && vm.hasAnyBilledAmount()\">\n" +
    "    <bm-compose-totals-summary billed-amount=\"vm.invoice.$invoiceSummaryTotalsBilledAmount\" compose-amount=\"vm.composeData.$totalAmount\" />\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/detail.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.data[{{detailIndex}}]\" field=\"{{fieldName}}\" field-type=\"{{fieldType}}\" is-grid-row=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-1-amount.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-1-amount.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}]\" field=\"$amount\" is-read-only=\"!vm.data.groupings[{{rowIndex}}].detail\" field-type=\"{{fieldType}}\" hide-zero-values=\"false\" is-grid-row=\"true\" is-amount-field=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-1-name.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-1-name.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}]\" field=\"groupByName\" is-group-one=\"true\" field-type=\"{{fieldType}}\" is-grid-row=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-2-amount.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-2-amount.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}]\" field=\"$amount\" is-read-only=\"!vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}].detail\" field-type=\"{{fieldType}}\" hide-zero-values=\"false\" is-grid-row=\"true\" is-amount-field=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-2-name.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-2-name.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}]\" field=\"groupByName\" field-type=\"{{fieldType}}\" is-grid-row=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-3-amount.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-3-amount.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}].childGroupings[{{rowIndex3}}]\" field=\"$amount\" is-read-only=\"!vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}].childGroupings[{{rowIndex3}}].detail\" field-type=\"{{fieldType}}\" hide-zero-values=\"false\" is-grid-row=\"true\" is-amount-field=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/group-3-name.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/group-3-name.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.groupings[{{rowIndex}}].childGroupings[{{rowIndex2}}].childGroupings[{{rowIndex3}}]\" field=\"groupByName\" field-type=\"{{fieldType}}\" is-grid-row=\"true\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/compose/layout-fields/report-params.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/compose/layout-fields/report-params.html",
    "<bm-practice-billing-compose-froala-field editors= \"vm.editors\" object=\"vm.data.reportParams\" field=\"{{fieldName}}\" field-type=\"{{fieldType}}\" is-grid-row=\"false\"></bm-practice-billing-compose-froala-field>");
}]);

angular.module("main/src/detail-billing/detail-billing-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/detail-billing-directive.html",
    "<!-- data is -->\n" +
    "<ng-form name=\"detailBillForm\">\n" +
    "    <bmp-page-header class=\"detail-billing-header\">\n" +
    "        <bmp-page-header-left-content>\n" +
    "            <h1 data-qe-id=\"bm-detailBillForm-header-text\" class=\"bmp-page-header-truncate\">{{'Bluemoon.Billing.DetailBilling' | translate }}: {{vm.data.client.name}}</h1>\n" +
    "        </bmp-page-header-left-content>\n" +
    "        <bmp-page-header-right-content>\n" +
    "            <button type=\"button\" id=\"detailBillForm-save\" data-qe-id=\"bm-detailBillForm-save\" class=\"btn btn-primary\" data-ng-click=\"vm.saveButtonClicked()\"\n" +
    "                ng-disabled=\"vm.calculating && vm.$scope.detailBillForm.$invalid\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "            <button type=\"button\" id=\"detailBillForm-cancel\" data-qe-id=\"bm-detailBillForm-cancel\" class=\"btn btn-default\" data-ng-click=\"vm.cancelButtonClicked()\"\n" +
    "                data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "        </bmp-page-header-right-content>\n" +
    "    </bmp-page-header>\n" +
    "\n" +
    "    <div class=\"detail-billing-container\" bento-busy-loader=\"vm.busyLoaderVisible\">\n" +
    "\n" +
    "\n" +
    "        <!-- Grid -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <bmp-view-mode-tabset bmp-view-mode-tabset-tabs=\"vm.tabs\">\n" +
    "                    <ng-include ng-if=\"vm.activeTab !== 0\" src=\"'main/src/detail-billing/detail-billing-summary.html'\"></ng-include>\n" +
    "                    <div data-ng-if=\"vm.activeTab === 0 && vm.data\">\n" +
    "\n" +
    "                        <h2>{{ 'Bluemoon.Billing.DetailBilling.SummaryTab' | translate }}</h2>\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Invoice Format -->\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"invoiceReportDefinition\" data-bmp-control-group-label=\"{{'Core.Captions.Invoice.InvoiceReportDefinition' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.invoice, 'invoiceReportDefinition')\" class=\"col-lg-3 col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <bmp-select-combo list=\"report-definition#invoice\" name=\"invoiceReportDefinition\" list-style=\"basic\" ng-model=\"vm.$invoiceReportDefinition\"\n" +
    "                                    data-ng-disabled=\"vm.calculating\" required=\"true\">\n" +
    "                                </bmp-select-combo>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- container for \"invoice data\" and \"invoice properties link\" -->\n" +
    "                            <div class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <!-- invoice date -->\n" +
    "                                    <div class=\"col-sm-4\" ng-class=\"{'has-error': vm.invoiceDateError}\">\n" +
    "                                        <!-- /* i18nextract */'Bluemoon.Billing.WipByProject.AsOfDate' -->\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-field-id=\"invoiceDate\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Bluemoon.Billing.WipByProject.AsOfDate' | translate | bmRequiredMark}}\"\n" +
    "                                            data-bmp-control-group-error=\"\"\n" +
    "                                            class=\"\">\n" +
    "                                            <bmp-bento-datepicker-wrapper\n" +
    "                                                name=\"invoiceDate\"\n" +
    "                                                id=\"invoiceDate\"\n" +
    "                                                ng-required=\"true\"\n" +
    "                                                ng-model=\"vm.datePickerValues.invoiceDate\"\n" +
    "                                                data-ng-change=\"vm.soloInvoiceDateChanged()\">\n" +
    "                                            </bmp-bento-datepicker-wrapper>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <!-- invoice properties link -->\n" +
    "                                    <div class=\"col-xs-4\">\n" +
    "                                        <div class=\"invoice-properties-link-container\">\n" +
    "                                            <a class=\"invoice-properties-link\" ng-click=\"vm.openInvoicePropertiesDialog()\">{{ 'Bluemoon.Billing.DetailBilling.InvoiceProperties' | translate }}</a>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Billing Instructions -->\n" +
    "                        <div class= \"row\">\n" +
    "                                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"internalNotes\" data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.BillingInstructions' | translate }}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, '$billingInstructions')\" class=\"col-xs-12\">\n" +
    "                                    <div class=\"billing-instructions-text\">{{ vm.$billingInstructions }}</div>\n" +
    "                                </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <ng-include src=\"'main/src/detail-billing/detail-billing-summary.html'\"></ng-include>\n" +
    "                        <div class=\"detail-billing-compose-box\">\n" +
    "                        <!-- Compose section -->\n" +
    "                        <bm-practice-billing-compose callback-obj=\"vm.callbackObj\" invoice=\"vm.data\" compose-data=\"vm.composeData\" is-active=\"vm.activeTab === 0\" dirty-handler=\"vm.dirtyHandler\" wip-through-date=\"vm.wipThroughDate\"\n" +
    "                        bill-by-type=\"vm.billByType\" current-selection-client-ids=\"vm.currentSelectionClientIds\"></bm-practice-billing-compose>\n" +
    "\n" +
    "                        <!-- [Surcharge, ...] row -->\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                <p class=\"form-control-static\">\n" +
    "                                    <span translate data-qe-id=\"bm-detailbillingsummary-surcharge-label\">Core.Captions.Invoice.Surcharge</span>\n" +
    "                                </p>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                <div class=\"footer-amounts\">\n" +
    "                                 <!-- [Surcharge, Surcharge field] currency -->\n" +
    "                                 <div data-bmp-control-group=\"\"\n" +
    "                                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.invoice, 'surcharge')\">\n" +
    "\n" +
    "                                    <input autocomplete=\"off\" type=\"text\" id=\"surcharge\" name=\"surcharge\" data-qe-id=\"bm-detailBillForm-surcharge-currency\"\n" +
    "                                        class=\"form-control input-lg\" style=\"text-align:right;\"\n" +
    "                                        type=\"text\"\n" +
    "                                        ng-model=\"vm.data.invoice.surcharge\"\n" +
    "                                        bmp-big-number=\"'c2'\"\n" +
    "                                        readonly=\"readonly\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Invoice.Surcharge\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- [Discount, ...] row -->\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                <p class=\"form-control-static\">\n" +
    "                                    <span translate data-qe-id=\"bm-detailbillingsummary-discount-label\">Core.Captions.Invoice.Discount</span>\n" +
    "                                </p>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                <div class=\"footer-amounts\">\n" +
    "                                    <!-- [Discount, Discount field] currency -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.invoice, 'discount')\">\n" +
    "\n" +
    "                                        <input autocomplete=\"off\" type=\"text\" id=\"discount\" name=\"discount\" data-qe-id=\"bm-detailBillForm-discount-currency\"\n" +
    "                                               ng-class=\"vm.calculating || vm.getHasAnyAppliedAmount() ? 'form-control detail-billing-readonly' : 'form-control'\" style=\"text-align:right;\"\n" +
    "                                               ng-model=\"vm.data.$discount\"\n" +
    "                                               ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                                               ng-change=\"vm.trackUserChange('billDiscount');\"\n" +
    "                                               disable-based-on-form-and-control-group=\"{{vm.calculating || vm.getHasAnyAppliedAmount()}}\"\n" +
    "                                               bmp-big-number=\"'c2'\"\n" +
    "                                               bmp-big-number-range-validator=\"\"\n" +
    "                                               bm-format-on-blur=\"\"\n" +
    "                                               min=\"0\" max=\"999999999999999.99\"\n" +
    "                                               bmp-control-group-field=\"Core.Captions.Invoice.Discount\" />\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- [Taxes, ...] row -->\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                <p class=\"form-control-static\">\n" +
    "                                    <span translate data-qe-id=\"bm-detailbillingsummary-tax-label\">Core.Captions.Invoice.IndirectTax</span>\n" +
    "                                </p>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                <div class=\"footer-amounts\">\n" +
    "                                    <!-- [Taxes row, Taxes field] currency -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.invoice, 'indirectTax')\">\n" +
    "\n" +
    "                                        <input autocomplete=\"off\" type=\"text\" id=\"indirectTax\" name=\"indirectTax\" data-qe-id=\"bm-detailBillForm-indirectTax-currency\"\n" +
    "                                               class=\"form-control input-lg\" style=\"text-align:right;\"\n" +
    "                                               type=\"text\"\n" +
    "                                               ng-model=\"vm.data.invoice.indirectTax\"\n" +
    "                                               bmp-big-number=\"'c2'\"\n" +
    "                                               readonly=\"readonly\"\n" +
    "                                               bmp-control-group-field=\"Core.Captions.Invoice.IndirectTax\" />\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- HR summation bar/line -->\n" +
    "                        <div class=\"row\" style=\"height: 15px;\">\n" +
    "                            <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-6 divider-lines\">\n" +
    "                                <hr style=\"height: 10px; margin-top: 0px; margin-bottom: 0px; border-bottom-style: hidden; border-color: #ccc\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- [Invoice Total, ...] row -->\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                <p class=\"form-control-static\">\n" +
    "                                    <span translate data-qe-id=\"bm-detailbillingsummary-invoiceTotal-label\">Core.Captions.Invoice.InvoiceTotal</span>\n" +
    "                                </p>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                <div class=\"footer-amounts\">\n" +
    "                                    <!-- [Invoice Total, Invoice Total field] currency -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.invoice, 'invoiceTotal')\">\n" +
    "\n" +
    "                                        <input autocomplete=\"off\" type=\"text\" id=\"invoiceTotal\" name=\"invoiceTotal\" data-qe-id=\"bm-detailBillForm-invoiceTotal-currency\"\n" +
    "                                               class=\"form-control input-lg\" style=\"text-align:right;\"\n" +
    "                                               type=\"text\"\n" +
    "                                               ng-model=\"vm.data.invoice.invoiceTotal\"\n" +
    "                                               bmp-big-number=\"'c2'\"\n" +
    "                                               readonly=\"readonly\"\n" +
    "                                               bmp-control-group-field=\"Core.Captions.Invoice.InvoiceTotal\" />\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Applied Amounts -->\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                    <p class=\"form-control-static\">\n" +
    "                                        <span translate data-qe-id=\"bm-detailbillingsummary-appliedcredits-label\">Bluemoon.Billing.DetailBilling.AppliedAmounts.Header</span>\n" +
    "                                    </p>\n" +
    "                                </div>\n" +
    "\n" +
    "                                <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                    <div class=\"footer-amounts\">\n" +
    "                                        <div data-bmp-control-group=\"\" ng-if=\"vm.applyAmountsLinkVisible()\"\n" +
    "                                            class=\"applied-link\" style=\"text-align:right;\">\n" +
    "                                            <a class=\"form-control-static\" ng-click=\"vm.displayAppliedAmountsModal()\"\n" +
    "                                            data-qe-id=\"bm-detailbillingsummary-applyAmounts-link\">{{vm.currentAppliedAmount}}</a>\n" +
    "                                        </div>\n" +
    "                                        <div data-bmp-control-group=\"\" ng-if=\"!vm.applyAmountsLinkVisible()\">\n" +
    "                                            <input autocomplete=\"off\" type=\"text\" id=\"applyAmountsStatic\" name=\"applyAmountsStatic\" data-qe-id=\"bm-detailBillForm-appliedAmounts-static\"\n" +
    "                                                class=\"form-control input-lg\" style=\"text-align:right;\"\n" +
    "                                                ng-model=\"vm.currentAppliedAmount\"\n" +
    "                                                readonly=\"readonly\"\n" +
    "                                                bmp-control-group-field=\"Bluemoon.Billing.DetailBilling.AppliedAmounts.Header\" />\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- HR summation bar/line -->\n" +
    "                        <div class=\"row\" style=\"height: 15px;\">\n" +
    "                            <div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-6 divider-lines\">\n" +
    "                                <hr style=\"height: 10px; margin-top: 0px; margin-bottom: 0px; border-bottom-style: hidden; border-color: #ccc\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Amount Due -->\n" +
    "                            <div class=\"col-lg-10 col-md-9 col-sm-8 col-xs-6\" style=\"text-align:right;\">\n" +
    "                                    <p class=\"form-control-static\">\n" +
    "                                        <span translate data-qe-id=\"bm-detailbillingsummary-appliedcredits-label\">Bluemoon.Billing.DetailBilling.AmountDue</span>\n" +
    "                                    </p>\n" +
    "                                </div>\n" +
    "\n" +
    "                                <div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-6\">\n" +
    "                                    <div class=\"footer-amounts\">\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            style=\"text-align:right;\">\n" +
    "                                            <input autocomplete=\"off\" type=\"text\" id=\"amountDue\" name=\"amountDue\" data-qe-id=\"bm-detailBillForm-amountDue\"\n" +
    "                                                class=\"form-control input-lg\" style=\"text-align:right;\"\n" +
    "                                                type=\"text\"\n" +
    "                                                ng-model=\"vm.$invoiceTotalAmountDue\"\n" +
    "                                                bmp-big-number=\"'c2'\"\n" +
    "                                                readonly=\"readonly\"\n" +
    "                                                bmp-control-group-field=\"Bluemoon.Billing.DetailBilling.AmountDue\" />\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                        <!-- Required  -->\n" +
    "                        <div class=row>\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <div class=\"bm-detailBillForm-legend-container\">\n" +
    "                                    <span data-qe-id=\"bm-detailBillForm-legend\">{{'Bluemoon.Practice.Common.Grid.RequiredItems' | translate}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <!-- Billable tab -->\n" +
    "                    <div data-ng-if=\"vm.data && vm.activeTab === 1\">\n" +
    "                        <detail-billing-billable model=\"vm.data\" form=\"vm.form\" has-applied-amounts=\"vm.getHasAnyAppliedAmount()\" is-itemized-invoice=\"vm.useItemizedInvoice\"></detail-billing-billable>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <!-- Non-Billable tab -->\n" +
    "                    <div data-ng-if=\"vm.data && vm.activeTab === 2\">\n" +
    "                        <detail-billing-non-billable model=\"vm.data\" form=\"vm.form\"></detail-billing-non-billable>\n" +
    "                    </div> <!-- Non-Billable tab end-->\n" +
    "\n" +
    "                    <!-- Preview tab -->\n" +
    "                    <div data-ng-if=\"vm.activeTab === 5\" class=\"detail-billing-preview overflow-preview\">\n" +
    "                        <bm-practice-invoice-pdf-renderer invoice=\"vm.data\" compose-data=\"vm.composeData\" applied-amounts=\"{data: vm.appliedAmounts, isDirty: vm.appliedAmountsIsDirty}\" dirty-handler=\"vm.dirtyHandler\" ></bm-practice-invoice-pdf-renderer>\n" +
    "                    </div>\n" +
    "\n" +
    "                </bmp-view-mode-tabset>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("main/src/detail-billing/detail-billing-receipts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/detail-billing-receipts.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    <span translate=\"Bluemoon.Billing.DetailBilling.AppliedAmounts.Header\"></span>\n" +
    "</div>\n" +
    "<div class=\"bmp-summary-blocks\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-6\" data-qe-id=\"bm-appliedAmounts-amount-label\">{{ ctrl.getAmountSummaryHeaderText() }}\n" +
    "			<p>{{ctrl.formatNumberForGrid(receiptAmount, 'C2')}}</p>\n" +
    "		</div>\n" +
    "		<div class=\"col-xs-6\" data-qe-id=\"bm-appliedAmounts-openAmount-label\">{{'Core.Captions.AccountsReceivableOpen.NormalOpenAmount' | translate }}\n" +
    "			<p>{{ctrl.formatNumberForGrid(appliedAmounts.accountsReceivableOpen.normalOpenAmount,'C2')}}</p>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"well bm-well bmp-summary-blocks-detail\">\n" +
    "<div bento-busy-loader=\"ctrl.showBusy\" bento-busy-loader-size=\"small\">\n" +
    "	<!-- /* i18nextract */''Bluemoon.Practice.Common.Actions.Export' -->\n" +
    "	<bmp-toolbar grid-data=\"ctrl.flexGrid\"\n" +
    "		toolbar-buttons=\"ctrl.toolbarButtonDefinition\"\n" +
    "		has-search=\"false\"\n" +
    "		has-column-picker=\"false\">\n" +
    "	</bmp-toolbar>\n" +
    "\n" +
    "	<wj-flex-grid ng-if=\"!ctrl.showBusy\"\n" +
    "		control=\"ctrl.flexGrid\"\n" +
    "		items-source=\"appliedAmounts.applications\"\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		headers-visibility=\"Column\"\n" +
    "		selection-mode=\"Cell\"\n" +
    "		is-read-only=\"false\"\n" +
    "		allow-sorting=\"false\"\n" +
    "		item-formatter=\"ctrl.itemFormatter\"\n" +
    "		items-source-changed=\"ctrl.flexGridItemsSourceChanged(s,e)\"\n" +
    "		initialized=\"gridInitialized(s,e)\"\n" +
    "		cell-edit-ended=\"ctrl.gridCellEditEnded(s,e)\">\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableOpen.Client' | translate }}\"\n" +
    "			binding=\"accountsReceivable.client.name\">\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableApplication.AccountsReceivable' | translate }}\">\n" +
    "			<span>{{ctrl.getARApplicationDescription($item)}}</span>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableOpen.Reference' | translate }}\"\n" +
    "			binding=\"accountsReceivable.reference\">\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableOpen.EntryDate' | translate }}\"\n" +
    "			binding=\"accountsReceivable.entryDate\">\n" +
    "			<span>{{$item.accountsReceivable.entryDate | bmpDate}}</span>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableApplication.OriginalAmount' | translate }}\"\n" +
    "			binding=\"originalAmount\"\n" +
    "			align=\"right\">\n" +
    "			<span>{{ctrl.formatNumberForOriginalAmount($item, $item.originalAmount, 'C2')}}</span>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableApplication.Balance' | translate }}\"\n" +
    "			binding=\"balance\"\n" +
    "			align=\"right\">\n" +
    "			<span>{{ctrl.formatNumberForGrid($item.balance, 'C2')}}</span>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"*\"\n" +
    "			header=\"{{ 'Core.Captions.AccountsReceivableDetailClosed.AppliedAmount' | translate }}\"\n" +
    "			input-type=\"number\"\n" +
    "			binding=\"appliedAmount\"\n" +
    "			align=\"right\">\n" +
    "			<span data-qe-id=\"bm-appliedAmounts-appliedAmount-input\">{{ctrl.formatNumberForGrid($item.appliedAmount, 'C2')}}</span>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"CellEdit\">\n" +
    "				<input\n" +
    "					style=\"text-align: right; font-size: inherit; height: 100%; width: 100%\"\n" +
    "					name=\"appliedAmount\"\n" +
    "					type=\"text\"\n" +
    "					class=\"input-sm\"\n" +
    "					data-ng-model=\"$value\"\n" +
    "					data-bmp-clear-value=\"0\"\n" +
    "					data-bmp-big-number=\"c2\"\n" +
    "					data-qe-id=\"bm-appliedAmounts-appliedAmount-input\"/>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "</div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"save()\" translate data-qe-id=\"bm-appliedAmounts-save-button\">Bluemoon.Practice.Common.Actions.Save</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancel()\" translate data-qe-id=\"bm-appliedAmounts-cancel-button\">Bluemoon.Practice.Common.Buttons.Cancel</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/detail-billing-smart-bill-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/detail-billing-smart-bill-modal.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "<div class=\"modal-header\">\n" +
    "    <span translate-value-client=\"{{vm.data.client.name}}\"\n" +
    "            translate=\"Bluemoon.Billing.DetailBilling.QuickBillModal.Header\">\n" +
    "    </span>\n" +
    "</div>\n" +
    "<div ng-form name=\"quickBillForm\" bmp-detail-view-default-focus=\"invoiceTotalAmounts\">\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Selected Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"workInProgressAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.QuickBill.SelectedAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"errorFor(invoiceTotalAmounts, 'workInProgressAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"workInProgressAmount\"\n" +
    "                    data-qe-id=\"bm-quickBillForm-workInProgressAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    disabled class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"invoiceTotalAmounts.workInProgressAmount\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Bluemoon.Billing.DetailBilling.QuickBill.SelectedAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Billed Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"billedAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.BilledAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"errorFor(invoiceTotalAmounts, 'billedAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"billedAmount\"\n" +
    "                    data-qe-id=\"bm-quickBillForm-billedAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"invoiceTotalAmounts.billedAmount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"clearErrorFor(invoiceTotalAmounts,'billedAmount'); recalculate('$.data.billedAmount')\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.BilledAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Adjusted Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"adjustmentAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.AdjustmentAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"errorFor(invoiceTotalAmounts, 'adjustmentAmount')\"\n" +
    "                append-to-parent=\"\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"adjustmentAmount\"\n" +
    "                    data-qe-id=\"bm-quickBillForm-adjustmentAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"invoiceTotalAmounts.adjustmentAmount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"clearErrorFor(invoiceTotalAmounts,'adjustmentAmount'); recalculate('$.data.adjustmentAmount')\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.AdjustmentAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Carryover Amount -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"carryoverAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.InvoiceDetailAmounts.CarryoverAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"errorFor(invoiceTotalAmounts, 'carryoverAmount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" name=\"carryoverAmount\"\n" +
    "                     data-qe-id=\"bm-quickBillForm-carryoverAmount-number\"\n" +
    "                    type=\"text\"\n" +
    "                    disabled class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"invoiceTotalAmounts.carryoverAmount\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.InvoiceDetailAmounts.CarryoverAmount\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button\n" +
    "        data-qe-id=\"bm-quickBillForm-save-button\"\n" +
    "        class=\"btn btn-primary\"\n" +
    "        ng-click=\"save()\"\n" +
    "        translate>Bluemoon.Practice.Common.Actions.Save</button>\n" +
    "\n" +
    "	<button\n" +
    "        data-qe-id=\"bm-quickBillForm-cancel-button\"\n" +
    "        class=\"btn btn-default\"\n" +
    "        ng-click=\"cancel()\"\n" +
    "    translate>Bluemoon.Practice.Common.Buttons.Cancel</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/detail-billing-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/detail-billing-summary.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"bmp-summary-blocks\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-xs-2\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.InvoiceDate\"\n" +
    "                        data-qe-id=\"bm-billableEntries-invoiceDate-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-invoiceDate-value\">\n" +
    "                            {{vm.data.entryDate | bmpDate}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-2 text-right\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.SummaryTotals.TotalWipTime\"\n" +
    "                        data-qe-id=\"bm-billableEntries-wip-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-wip-value\">\n" +
    "                            {{vm.data.invoice.summaryTotals.workInProgressAmount || '0' | bmpNumber:'c'}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-2 text-right\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.SummaryTotals.SelectedWipTime\"\n" +
    "                        data-qe-id=\"bm-billableEntries-billed-wip-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-selected-wip-value\">\n" +
    "                            {{vm.data.$invoiceSummaryTotalsWorkInProgressAmount || '0' | bmpNumber:'c'}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-2 text-right\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.SummaryTotals.BillTime\"\n" +
    "                        data-qe-id=\"bm-billableEntries-bill-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-bill-value\">\n" +
    "                            {{vm.data.$invoiceSummaryTotalsBilledAmount || '0' | bmpNumber:'c'}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-2 text-right\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.SummaryTotals.AdjustTime\"\n" +
    "                        data-qe-id=\"bm-billableEntries-adjust-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-adjust-value\">\n" +
    "                            {{vm.data.$invoiceSummaryTotalsAdjustmentAmount || '0' | bmpNumber:'c'}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-xs-2 text-right\">\n" +
    "                    <div translate=\"Bluemoon.Billing.DetailBilling.SummaryTotals.CarryoverTime\"\n" +
    "                        data-qe-id=\"bm-billableEntries-carryover-label\"></div>\n" +
    "                    <div>\n" +
    "                        <p ng-if=\"vm.data\" data-qe-id=\"bm-billableEntries-carryover-value\">\n" +
    "                            {{vm.data.$invoiceSummaryTotalsCarryoverAmount || '0' | bmpNumber:'c'}}\n" +
    "                        </p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/invoice-properties-dialog/invoice-properties-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/invoice-properties-dialog/invoice-properties-dialog.html",
    "<div id=\"invoice-properties-dialog\">\n" +
    "<ng-form name=\"invoicePropertiesDialogForm\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button\n" +
    "            type=\"button\"\n" +
    "            class=\"close\"\n" +
    "            ng-click=\"vm.dismissDialog()\"\n" +
    "            aria-hidden=\"true\"\n" +
    "        >\n" +
    "            &times;\n" +
    "        </button>\n" +
    "        Invoice Properties <!-- will use stored string/label once it became available -->\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"modal-body\">\n" +
    "        <!-- 1st row -->\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"entryNumber\" data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.EntryNumber' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'entryNumber')\" class=\"col-sm-4 col-xs-12\">\n" +
    "                <input type=\"number\" autocomplete=\"off\" class=\"form-control\" data-qe-id=\"bm-detailBillForm-invoiceNumber-number\"\n" +
    "                    name=\"entryNumber\" ng-model=\"vm.entryNumber\" bmp-integer min=\"1\" max=\"99999999999\" data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                    disable-based-on-form-and-control-group=\"\" data-bmp-entity-code=\"\" data-bmp-entity-code-id=\"vm.invoiceId\" data-bmp-entity-code-type=\"invoices\"\n" +
    "                    data-bmp-entity-code-options=\"{typeId: 'INVOICE'}\"\n" +
    "                    bmp-focus-on-construct=\"true\" bmp-control-group-field=\"Core.Captions.AccountsReceivable.EntryNumber\"\n" +
    "                    placeholder=\"{{'Bluemoon.Billing.DetailBilling.NextAvailablePlaceholder' | translate}}\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"reference\" data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Reference' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'reference')\" class=\"col-sm-4 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" type=\"text\" data-qe-id=\"bm-detailBillForm-referenceNumber-text\" name=\"reference\" bmp-control-group-field=\"Core.Captions.AccountsReceivable.Reference\"\n" +
    "                    class=\"form-control input-lg\" data-ng-model=\"vm.reference\" data-ng-disabled=\"vm.calculating\"\n" +
    "                    data-fef-maxlength=\"30\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- 2nd row -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <invoice-due-date-selector\n" +
    "                    ng-model=\"vm.datePickerValues\"\n" +
    "                    name=\"invoiceDate\"\n" +
    "                    invoice-date-selector-label=\"\"\n" +
    "                    dates-are-valid=\"vm.datesAreValid\">\n" +
    "                </invoice-due-date-selector>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- 3rd row -->\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"notes\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.DetailBilling.InvoiceComments' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'notes')\" class=\"col-lg-12 col-md-14 col-sm-14 col-xs-14\">\n" +
    "                <bmp-standard-text-input\n" +
    "                    id=\"notes\"\n" +
    "                    label=\"{{'Bluemoon.Billing.DetailBilling.InvoiceComments' | translate}}\"\n" +
    "                    data-qe-id=\"bm-detailBillForm-billingInstructions-text\"\n" +
    "                    name=\"notes\"\n" +
    "                    data-ng-model=\"vm.notes\"\n" +
    "                    data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'notes')\" data-ng-disabled=\"vm.calculating\"></bmp-standard-text-input>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button\n" +
    "                class=\"btn btn-primary\"\n" +
    "                ng-click=\"vm.saveChanges()\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Save\">\n" +
    "            </button>\n" +
    "            <button\n" +
    "                class=\"btn btn-default\"\n" +
    "                ng-click=\"vm.dismissDialog()\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Close\">\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/multi-client-detail-billing-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/multi-client-detail-billing-directive.html",
    "<!-- data is -->\n" +
    "<div class=\"ng-form\" name=\"multiClientDtailBillingForm\">\n" +
    "  <div bento-splitter-group\n" +
    "        left-width=\"{{vm.selectionSlideoutEnabled ? '425' : '0'}}px\"\n" +
    "        left-max-width=\"{{vm.selectionSlideoutEnabled ? '425' : '0'}}px\"\n" +
    "        right-width=\"425px\"\n" +
    "        right-max-width=\"800px\"\n" +
    "        top-height=\"100px\"\n" +
    "        top-max-height=\"100px\"\n" +
    "        bottom-height=\"100px\"\n" +
    "        bottom-max-height=\"100px\"\n" +
    "        resizable=\"true\"\n" +
    "        event-tracking=\"vm.trackEvent(eventName)\"\n" +
    "        is-left-collapsed=\"vm.selectionSlideoutCollapsed\"\n" +
    "        is-right-collapsed=\"vm.priorInvoicesSlideoutCollapsed\"\n" +
    "        id=\"splitter-group-left-demo\"\n" +
    "        ng-class=\"{'detail-billing-splitter-group-left-hidden': !vm.selectionSlideoutEnabled}\">\n" +
    "\n" +
    "    <aside bento-splitter-group-left>\n" +
    "      <div class=\"bento-container\">\n" +
    "\n" +
    "        <article class=\"panel panel-default detail-billing-panel\">\n" +
    "            <div class=\"panel-heading\" translate=\"Bluemoon.Billing.MultiClientDetailBilling.Selection\"></div>\n" +
    "            <div class=\"panel-body panel-list\">\n" +
    "                <ul class=\"list-group\">\n" +
    "                    <li class=\"list-group-item\" ng-repeat=\"client in vm.clientData\">\n" +
    "                        <h4 class=\"h4\">\n" +
    "                          <a href=\"\" ng-click=\"vm.onRowClicked($index, 0)\">{{client.clientName}}</a>\n" +
    "                          <span class=\"label label-info\" translate=\"Bluemoon.Billing.MultiClientDetailBilling.Billed\" ng-if=\"client.checkboxChecked\"></span>\n" +
    "                        </h4>\n" +
    "                        <ul class=\"list-group\">\n" +
    "                          <li class=\"list-group-item client-child\" ng-repeat=\"child in client.billingGroupClientNames\">\n" +
    "                            <span>{{child.name}}</span>\n" +
    "                          </li>\n" +
    "                        </ul>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </article>\n" +
    "\n" +
    "      </div>\n" +
    "    </aside>\n" +
    "\n" +
    "    <section roe=\"main\" class=\"bento-splitter-group-main animate\" tabindex=\"0\">\n" +
    "      <div class=\"bento-splitter-group-main-inner\">\n" +
    "        <div class=\"bento-container detail-billing\">\n" +
    "          <trta-practice-billing-invoice-details\n" +
    "            on-save=\"vm.onSave(invoice)\"\n" +
    "            on-save-button-clicked=\"vm.onSaveButtonClicked()\"\n" +
    "            on-open=\"vm.onOpen(invoice)\"\n" +
    "            on-cancel=\"vm.onCancel()\">\n" +
    "        </trta-practice-billing-invoice-details>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </section>\n" +
    "\n" +
    "    <aside bento-splitter-group-right>\n" +
    "      <div class=\"bento-container\">\n" +
    "          <h3 translate=\"Bluemoon.Practice.Widget.PriorInvoices.Title\"></h3>\n" +
    "          <bm-practice-widget widget=\"prior-invoices\" context=\"vm.currentInvoice().billingSelection.client\" date-selector=\"false\"></bm-practice-widget>\n" +
    "      </div>\n" +
    "    </aside>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/detail-billing/non-billable/detail-billing-non-billable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/non-billable/detail-billing-non-billable.html",
    "<bmp-grid ng-if=\"vm.service\" bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>");
}]);

angular.module("main/src/detail-billing/preview/invoice-pdf-renderer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/detail-billing/preview/invoice-pdf-renderer.html",
    "<div bento-busy-loader=\"vm.busyLoaderVisible\" class=\"bm-practice-invoice-pdf-renderer-height\">\n" +
    "    <div ng-if=\"!vm.busyLoaderVisible && !vm.hasData\" class=\"bm-practice-invoice-pdf-renderer-failed\">\n" +
    "        <i class=\"bento-icon-empty-list\"></i>\n" +
    "        <h3 translate=\"Bluemoon.Billing.DetailBilling.Preview.UnableToLoadPreview\"></h3>\n" +
    "    </div>\n" +
    "\n" +
    "    <pdf-renderer id=\"renderer\" initialzoom=\"1.3\" class=\"bm-practice-invoice-pdf-renderer-height\" ng-class=\"{'bm-practice-invoice-pdf-renderer-view-has-data':vm.hasData}\"></pdf-renderer>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/fixed-fee-billing/fixed-fee-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/fixed-fee-billing/fixed-fee-billing.html",
    "<h1 class=\"no-top-margin\" translate=\"Bluemoon.Billing.FixedFee.Title\"></h1>\n" +
    "\n" +
    "<div class=\"row\" ng-form=\"fixedFeeForm\">\n" +
    "    <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "        <invoice-date-selector\n" +
    "            ng-model=\"vm.customParams.datePickerValues\"\n" +
    "            name=\"invoiceDate\"\n" +
    "            invoice-date-selector-label=\"\"\n" +
    "            invoice-date-selector-changed=\"vm.invoiceDateSelectorChanged()\"\n" +
    "            wip-date-selector-changed=\"vm.wipDateSelectorChanged()\"\n" +
    "            dates-are-valid=\"vm.datesAreValid\"></invoice-date-selector>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Frequency -->\n" +
    "    <div class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"frequency\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Billing.FixedFee.Frequency' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"\">\n" +
    "            <bmp-enum-combo name=\"frequency\"\n" +
    "                            enum=\"fixed-fee-billing-template-frequency\"\n" +
    "                            ng-model=\"vm.frequency\"\n" +
    "                            on-change=\"vm.refreshGrid()\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                  bmp-grid-service=\"vm.fixedFeeService\"\n" +
    "                  bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/format-templates-page.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/format-templates-page.html",
    "<div class=\"container-fluid no-padding-l\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmp-routable-tabset bmp-routable-tabset-tabs=\"vm.tabs\">\n" +
    "                <div ui-view class=\"enter-item-animation\"></div>\n" +
    "            </bmp-routable-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/format-templates/invoice-format-wizard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard.html",
    "<form id=\"invoiceFormatWizardForm\" name=\"invoiceFormatWizardForm\" novalidate>\n" +
    "    <div  bento-busy-loader=\"vm.detail.isLoadingData()\" class=\"bm-billing-invoice-format-wizard\">\n" +
    "        <h1 ng-if=\"vm.detail.isNew\" class=\"no-top-margin\"\n" +
    "            data-qe-id=\"header-title\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.AddHeaderTitle\">\n" +
    "        </h1>\n" +
    "        <h1 ng-if=\"!vm.detail.isNew\" class=\"no-top-margin\"\n" +
    "            data-qe-id=\"header-title\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.EditHeaderTitle\" translate-values=\"{ name: vm.data.name }\">\n" +
    "        </h1>\n" +
    "        <div bento-wizard\n" +
    "                current-step=\"vm.currentStep\"\n" +
    "                on-change=\"vm.onWizardChange(step)\"\n" +
    "                on-finish=\"vm.onWizardFinish()\">\n" +
    "            <!-- Define step titles and descriptions -->\n" +
    "            <ol class=\"steps\">\n" +
    "            <li class=\"wizardElement\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.MainStepHeader\"></span>\n" +
    "            </li>\n" +
    "            <li class=\"wizardElement\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.BillingInformationStepHeader\"></span>\n" +
    "            </li>\n" +
    "            <li class=\"wizardElement\">\n" +
    "                <span class=\"title\" data-qe-id=\"AR-Information-WizardHeader\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.ARInformationStepHeader\"></span>\n" +
    "            </li>\n" +
    "            </ol>\n" +
    "\n" +
    "            <!-- Define step content -->\n" +
    "            <ul class=\"contents\">\n" +
    "                <li>\n" +
    "                    <!-- Main content -->\n" +
    "                    <ng-form id=\"invoiceFormatWizardForm-step0\" name=\"invoiceFormatWizardForm-step0\">\n" +
    "                        <bm-practice-billing-invoice-format-wizard-main model=\"vm.wizardModel\" form=\"vm.getForm(0)\" detail=\"vm.detail\">\n" +
    "                        </bm-practice-billing-invoice-format-wizard-main>\n" +
    "                    </ng-form>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <!-- Billing Information content -->\n" +
    "                    <ng-form id=\"invoiceFormatWizardForm-step1\" name=\"invoiceFormatWizardForm-step1\">\n" +
    "                        <bm-practice-billing-invoice-format-wizard-billing model=\"vm.wizardModel\" screen-data=\"vm.screenData\"></bm-practice-billing-invoice-format-wizard-billing>\n" +
    "                    </ng-form>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <!-- A/R Information content -->\n" +
    "                    <ng-form id=\"invoiceFormatWizardForm-step2\" name=\"invoiceFormatWizardForm-step2\">\n" +
    "                        <bm-practice-billing-invoice-format-wizard-acc-rec model=\"vm.wizardModel\" screen-data=\"vm.screenData\"></bm-practice-billing-invoice-format-wizard-acc-rec>\n" +
    "                    </ng-form>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <!-- custom buttons -->\n" +
    "            <button class=\"btn btn-default pull-right interactiveElement\"\n" +
    "                    ng-click=\"vm.cancel()\">\n" +
    "            {{'Bluemoon.Practice.Common.Actions.Cancel' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
}]);

angular.module("main/src/format-templates/invoice-format-wizard/pages/accounts-receivable/invoice-format-wizard-accrec.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard/pages/accounts-receivable/invoice-format-wizard-accrec.html",
    "<div class=\"invoice-format-wizard-page\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-9 col-sm-8 col-xs-12\" bento-busy-loader=\"!ctrl.screenData\">\n" +
    "            <!-- AR info -->\n" +
    "            <div ng-repeat=\"option in ctrl.screenData.arCustomOptionItems\" role=\"presentation\">\n" +
    "                <fieldset>\n" +
    "                    <legend class=\"col-md-12 legend-element\" date-qe-id=\"AR-Information-Header-label\">{{option.name}}</legend>\n" +
    "                <div ng-repeat=\"customOption in option.customOptions | prioritizeUnpaidBalances\" ng-class=\"{'child-checkbox': customOption.id === 'INCLUDEPAYBYPHONE' ||\n" +
    "                                customOption.id === 'INCLUDEPAYONLINE' || customOption.id === 'PAYMENTWEBSITEINTEXT' || customOption.id === 'INCLUDEPAYBYMAIL' || customOption.id === 'INCLUDEPRIORUNPAIDBALANCES',\n" +
    "                                'parent-checkbox': customOption.id === 'INCLUDEARPAYSTUB'}\">\n" +
    "                    <div ng-if=\"(customOption.id !=='INCLUDEPAYBYPHONE' && customOption.id !=='INCLUDEPAYONLINE' && customOption.id !=='PAYMENTWEBSITEINTEXT'\n" +
    "                                && customOption.id !== 'INCLUDEPAYBYMAIL' && customOption.id !=='INCLUDEPRIORUNPAIDBALANCES')\" >\n" +
    "                        <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                            ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                    </div>\n" +
    "                    <div class=\"bmp-additional-sub-option\" ng-if=\"ctrl.model.customItems['INCLUDEARPAYSTUB'].value && ctrl.isNotBasicOrRoundedFormat\">\n" +
    "                        <div ng-if=\"customOption.id ==='INCLUDEPRIORUNPAIDBALANCES' || customOption.id ==='INCLUDEPAYBYPHONE' || customOption.id ==='INCLUDEPAYBYMAIL'\">\n" +
    "                            <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                            ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                        </div>\n" +
    "                        <div class=\"invoice-pay-online-inputs\" ng-if=\"customOption.id === 'INCLUDEPAYONLINE' && ctrl.model.customItems['INCLUDEARPAYSTUB'].value\">\n" +
    "                            <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                                ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                            <div ng-if=\"ctrl.model.customItems['INCLUDEPAYONLINE'].value === true\">\n" +
    "                                <input ng-model=\"ctrl.customItems['PAYMENTWEBSITEINTEXT'].value\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                </div>\n" +
    "                </fieldset>\n" +
    "            </div>\n" +
    "        <div ng-if=\"ctrl.model.customItems['INCLUDEARPAYSTUB'].value && ctrl.onIncludePayStubChange()\"></div>\n" +
    "        </div>\n" +
    "        <bm-practice-billing-invoice-format-wizard-preview model=\"ctrl.model\" step=\"INVOICEARINFO\"\n" +
    "            class=\"pull-right\"></bm-practice-billing-invoice-format-wizard-preview>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/invoice-format-wizard/pages/billing/invoice-format-wizard-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard/pages/billing/invoice-format-wizard-billing.html",
    "<div class=\"invoice-format-wizard-page\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-9 col-sm-8 col-xs-12\" bento-busy-loader=\"!ctrl.screenData\">\n" +
    "\n" +
    "            <!-- Lead in text -->\n" +
    "            <div class=\"row\" ng-if=\"ctrl.screenData.leadInCustomOption.length > 0\">\n" +
    "                <div class=\"col-md-12\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"leadInText\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.LeadInText' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(ctrl.model, 'leadInText')\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\" class=\"form-control interactiveElement\"\n" +
    "                            id=\"leadInText\" name=\"leadInText\"\n" +
    "                            ng-model=\"ctrl.model.leadInText\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Grouping options -->\n" +
    "            <div class=\"row\" ng-if=\"ctrl.screenData\">\n" +
    "                <div class=\"col-md-12\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"grouping\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.GroupingOptions' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(ctrl.model, 'grouping')\">\n" +
    "                    <bmp-group-sort name=\"grouping\"\n" +
    "                        items=\"ctrl.model.grouping\"\n" +
    "                        max-items=\"3\"\n" +
    "                        options=\"ctrl.screenData.groupByItems\"\n" +
    "                        bindings=\"ctrl.model.groupingBindings\"\n" +
    "                        additional-custom-options=\"ctrl.screenData.groupByCustomOptions\"></bmp-group-sort>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Entry detail -->\n" +
    "            <div ng-repeat=\"option in ctrl.screenData.billingCustomOptionItems\">\n" +
    "                <div class=\"row\"><label class=\"col-md-12\" date-qe-id=\"editInvoiceFormat-entrydetail-label\">{{option.name}}</label></div>\n" +
    "                <div ng-repeat=\"customOption in option.customOptions\">\n" +
    "                    <div ng-if=\"ctrl.isUSTemplateSelected\">\n" +
    "                        <bmp-additional-custom-options additional-option=\"customOption\" ng-model=\"ctrl.customOptionValue[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"!ctrl.isUSTemplateSelected\">\n" +
    "                        <div ng-if=\"customOption.id !== 'INCLUDECOMMENTS'\">\n" +
    "                            <bmp-additional-custom-options additional-option=\"customOption\" ng-model=\"ctrl.customOptionValueForComments[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"customOption.id === 'INCLUDECOMMENTS'\">\n" +
    "                            <bmp-additional-custom-options ng-class=\"{'disabled-bmp-additional-custom-options': customOption.id=='INCLUDECOMMENTS' && !ctrl.model.customItems['INCLUDEENTRYDETAIL'].value, 'bmp-additional-sub-option': customOption.id=='INCLUDECOMMENTS'}\" additional-option=\"customOption\" ng-model=\"ctrl.customOptionValueForComments[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <bm-practice-billing-invoice-format-wizard-preview model=\"ctrl.model\" step=\"INVOICEBILLINGINFO\" class=\"pull-right\"></bm-practice-billing-invoice-format-wizard-preview>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-carousel-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-carousel-card.html",
    "<div>\n" +
    "    <p id=\"{{card.dataQeId}}\" data-qe-id=\"{{card.dataQeId }}\">{{card.name}}</p>\n" +
    "    <img class=\"invoice-format-wizard-card-report-image\" src=\"{{card.genericPreviewImageUrl}}\" width=\"100%\" height=\"240\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-main.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-main.html",
    "<div>* {{'Bluemoon.DMS.Approvals.ConfirmModal.RequiredField' | translate}}</div><br/>\n" +
    "<div class=\"row\">\n" +
    "    <!-- /* i18nextract */'Core.Captions.CompanyLayoutOption.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"name\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.CompanyLayoutOption.Name' | translate | bmRequiredMark}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.model.data, 'name')\"\n" +
    "        class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"name\"\n" +
    "            name=\"name\"\n" +
    "            type=\"text\"\n" +
    "            aria-labelledby=\"name-label name-error available-msg pendingMsg\"\n" +
    "            class=\"form-control input-lg interactiveElement\"\n" +
    "            data-ng-model=\"vm.model.data.name\"\n" +
    "            data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "            bmp-default-focus\n" +
    "            data-ng-required=\"true\"\n" +
    "            data-bmp-entity-code=\"\"\n" +
    "            data-bmp-entity-code-id=\"vm.model.data.id\"\n" +
    "            data-bmp-entity-code-type=\"company-layout-options\"\n" +
    "            data-bmp-entity-code-options=\"{reportLayoutTypeId: 'INVOICE'}\"\n" +
    "            data-ng-change=\"vm.detail.clearErrorFor(vm.model.data, 'name')\" />\n" +
    "        <div class=\"pending-msg\" id=\"pendingMsg\" ng-if=\"vm.form.name.$dirty && vm.form.name.$pending\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.NonUniqueNamePendingMsg\"></div>\n" +
    "        <div class=\"valid-msg\" id=\"available-msg\" ng-if=\"vm.form.name.$dirty && vm.form.name.$valid\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.ValidNameMsg\" ></div>\n" +
    "        <div class=\"msg-space-holder\" id=\"name-valid\" ng-show=\"!vm.form.name.$dirty && !vm.form.name.$valid && !vm.form.name.$pending\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.ValidNameMsg\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <bmp-carousel name=\"reportDefinition\" bmp-carousel-cards=\"vm.styleCards\" bmp-carousel-card-template-url=\"vm.styleCardsTemplateUrl\" ng-model=\"vm.$reportDefinition\"></bmp-carousel>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!-- /* i18nextract */'Bluemoon.Billing.InvoiceFormatWizard.ShowStylesForCombo' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.ShowStylesForCombo' | translate | bmRequiredMark}}\"\n" +
    "        class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"custom\"\n" +
    "                custom-items=\"vm.countryIds\"\n" +
    "                ng-model=\"vm.styleCountryId\"\n" +
    "                value-property=\"id\"\n" +
    "                on-change=\"vm.refreshVisibleCards()\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-5 col-sm-6 col-xs-12\"\n" +
    "        data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.Logo' | translate}}\">\n" +
    "        <div bento-busy-loader=\"vm.model.$logoLoading\">\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" id=\"addImageBtn\" tabindex=\"0\" ng-click=\"vm.changeLogo()\" href=\"\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.Logo.Add\" ng-show=\"!vm.model.$logo.content\" ng-disabled=\"vm.model.$logoLoading\"></a>\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" tabindex=\"0\" href=\"\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.Logo.AddFromFirmSettings\" ng-show=\"!vm.model.$logo.content\" ng-disabled=\"vm.model.$logoLoading\" bm-if-perm=\"Internal.CurrentDevelopment\" data-qe-id=\"bm-invoiceFormatWizard-addFromFirmSettings-button\"></a>\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" tabindex=\"0\" ng-click=\"vm.changeLogo()\" href=\"\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.Logo.Change\" ng-show=\"!!vm.model.$logo.content\"></a>\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" tabindex=\"0\" ng-click=\"vm.removeLogo()\" href=\"\"\n" +
    "            translate=\"Bluemoon.Billing.InvoiceFormatWizard.Logo.Remove\" ng-show=\"!!vm.model.$logo.content\"></a>\n" +
    "            <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-7 col-sm-6 col-xs-12\"\n" +
    "        data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.Logo.Preview' | translate}}\"\n" +
    "        ng-if=\"!!vm.model.$logo.content\">\n" +
    "        <img class=\"bm-billing-invoice-format-wizard-logo-preview\" ng-src=\"{{ vm.model.$logo.content }}\" />\n" +
    "    </div>\n" +
    "    <div ng-if=\"(vm.model.data.reportDefinition.code === 'INVOICECOLOREDBOX' || vm.model.data.reportDefinition.code === 'INVOICECACOLOREDBOX')|| ( vm.model.data.reportDefinition.code === 'INVOICEUSWINDOWEDENVELOPE' || vm.model.data.reportDefinition.code === 'TEMPLATE1') || ( vm.model.data.reportDefinition.code === 'INVOICECAWINDOWEDENVELOPE' || vm.model.data.reportDefinition.code === 'INVOICECATEMPLATE1')\" class=\"row accent-color\" data-bmp-control-group=\"\">\n" +
    "        <div class=\"col-xs-12\" translate=\"Onvio.Setup.Theme.AccentColor\"></div>\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"accent-color-picker\">\n" +
    "                <div class=\"swatch\" data-ng-style=\"{'background-color' : '#fff' }\"\n" +
    "                    ng-class=\"{'none-selected': vm.isNoneColorOptionSelected, 'selected': !vm.isNoneColorOptionSelected}\" ng-click=\"vm.selectColor('')\">\n" +
    "                    <i class=\"bento-icon-close-x\"></i>\n" +
    "                </div>\n" +
    "                <div class=\"swatch\" ng-repeat=\"accentColor in vm.accentColors\"\n" +
    "                    data-ng-style=\"{'background-color' : accentColor.color }\" ng-class=\"{'selected': accentColor.selected}\"\n" +
    "                    ng-click=\"vm.selectColor(accentColor.color)\">\n" +
    "                    <i class=\"bento-icon-checkmark\" ng-if=\"accentColor.selected\"></i>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"custom-hex-options col-xs-12\">\n" +
    "            <bmp-additional-custom-options additional-option=\"vm.colorOptions\"\n" +
    "                ng-model=\"vm.customHexCodeOption\"></bmp-additional-custom-options>\n" +
    "            <!-- <input ng-model=\"ctrl.colorOptionValues['CUSTOMHEXCODEVALUE'].value\" /> -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"customHexCode\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.CustomHexCode' | translate | bmRequiredMark}}\"\n" +
    "                class=\"custom-hex col-sm-6 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"customHexCode\" type=\"text\" class=\"custom-hex-input form-control input-sm interactiveElement\"\n" +
    "                    aria-labelledby=\"customHexCode-label customHexCode-error-msg\"\n" +
    "                    data-ng-model=\"vm.colorOptionValues['CUSTOMHEXCODEVALUE'].value\"\n" +
    "                    data-ng-disabled = \"!vm.colorOptionValues['CUSTOMHEXCODE'].value\"\n" +
    "                    data-ng-required=\"{{vm.colorOptionValues['CUSTOMHEXCODE'].value ? true : false}}\" customHexCodeValidation/>\n" +
    "                <div id=\"customHexCode-error-msg\" class=\"invalid-msg\" ng-show=\"vm.form.customHexCode.$error.customHexCodeValidation\"\n" +
    "                    translate=\"Bluemoon.Billing.InvoiceFormatWizard.CustomHexCode.ValidateMessage\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-preview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-format-wizard/pages/invoice-format-wizard-preview.html",
    "<div style=\"display:grid; padding-bottom:5px;\">\n" +
    "    <button class=\"btn btn-default\"\n" +
    "        ng-click=\"ctrl.preview()\">\n" +
    "{{'Bluemoon.Billing.InvoiceFormatWizard.PreviewFormat' | translate}}\n" +
    "    </button>\n" +
    "</div>\n" +
    "<img class=\"invoice-format-wizard-card-report-image\" ng-src=\"{{ctrl.getImageSource()}}\" width=\"185\" height=\"240\">");
}]);

angular.module("main/src/format-templates/invoice-formats-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/invoice-formats-list.html",
    "<div>\n" +
    "    <h1 class=\"no-top-margin\"\n" +
    "        data-qe-id=\"header-title\">{{'Bluemoon.Billing.InvoiceFormats.HeaderTitle' | translate}}</h1>\n" +
    "\n" +
    "    <!-- Grid -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                    bmp-grid-service=\"vm.companyLayoutOptionService\"></bmp-grid>\n" +
    "            </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/format-templates/statement-format-wizard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-format-wizard.html",
    "<form id=\"statementFormatWizardForm\" name=\"statementFormatWizardForm\" novalidate>\n" +
    "    <div  bento-busy-loader=\"vm.detail.isLoadingData()\" class=\"bm-billing-statement-format-wizard\">\n" +
    "        <h1 ng-if=\"vm.detail.isNew\" class=\"no-top-margin\"\n" +
    "            data-qe-id=\"header-title\"\n" +
    "            translate=\"Bluemoon.Billing.StatementFormatWizard.AddHeaderTitle\">\n" +
    "        </h1>\n" +
    "        <h1 ng-if=\"!vm.detail.isNew\" class=\"no-top-margin\"\n" +
    "            data-qe-id=\"header-title\"\n" +
    "            translate=\"Bluemoon.Billing.StatementFormatWizard.EditHeaderTitle\" translate-values=\"{ name: vm.data.name }\">\n" +
    "        </h1>\n" +
    "        <div bento-wizard\n" +
    "                current-step=\"vm.currentStep\"\n" +
    "                on-change=\"vm.onWizardChange(step)\"\n" +
    "                on-finish=\"vm.onWizardFinish()\">\n" +
    "            <!-- Define step titles and descriptions -->\n" +
    "            <ol class=\"steps\">\n" +
    "            <li class=\"wizardElement\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Billing.StatementFormatWizard.MainStepHeader\"></span>\n" +
    "            </li>\n" +
    "            <li class=\"wizardElement\">\n" +
    "                <span class=\"title\" translate=\"Bluemoon.Billing.StatementFormatWizard.ARInformationStepHeader\"></span>\n" +
    "            </li>\n" +
    "            </ol>\n" +
    "\n" +
    "            <!-- Define step content -->\n" +
    "            <ul class=\"contents\">\n" +
    "                <li>\n" +
    "                    <!-- Main content -->\n" +
    "                    <ng-form id=\"statementFormatWizardForm-step0\" name=\"statementFormatWizardForm-step0\">\n" +
    "                        <bm-practice-billing-statement-format-wizard-main model=\"vm.wizardModel\" form=\"vm.getForm(0)\" detail=\"vm.detail\">\n" +
    "                        </bm-practice-billing-statement-format-wizard-main>\n" +
    "                    </ng-form>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <!-- A/R Information content -->\n" +
    "                    <ng-form id=\"statementFormatWizardForm-step2\" name=\"statementFormatWizardForm-step2\">\n" +
    "                        <bm-practice-billing-statement-format-wizard-acc-rec model=\"vm.wizardModel\" screen-data=\"vm.screenData\"></bm-practice-billing-statement-format-wizard-acc-rec>\n" +
    "                    </ng-form>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <!-- custom buttons -->\n" +
    "            <button class=\"btn btn-default pull-right interactiveElement\"\n" +
    "                    ng-click=\"vm.cancel()\">\n" +
    "            {{'Bluemoon.Practice.Common.Actions.Cancel' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
}]);

angular.module("main/src/format-templates/statement-format-wizard/pages/accounts-receivable/statement-format-wizard-accrec.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-format-wizard/pages/accounts-receivable/statement-format-wizard-accrec.html",
    "<div class=\"statement-format-wizard-page\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-9 col-sm-8 col-xs-12\" bento-busy-loader=\"!ctrl.screenData\">\n" +
    "\n" +
    "            <!-- Lead in text -->\n" +
    "            <div class=\"row\" ng-if=\"ctrl.screenData.leadInCustomOption.length > 0\">\n" +
    "                <div class=\"col-md-12\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"leadInText\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Billing.StatementFormatWizard.LeadInText' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(ctrl.model, 'leadInText')\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\" class=\"form-control interactiveElement\"\n" +
    "                            id=\"leadInText\" name=\"leadInText\"\n" +
    "                            ng-model=\"ctrl.model.leadInText\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- AR info -->\n" +
    "            <div ng-repeat=\"option in ctrl.screenData.arCustomOptionItems\">\n" +
    "                <fieldset>\n" +
    "                <legend class=\"col-md-12 legend-element\">{{option.name}}</legend>\n" +
    "                <div ng-repeat=\"customOption in option.customOptions\">\n" +
    "                    <bmp-additional-custom-options additional-option=\"customOption\" ng-model=\"ctrl.model.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                </div>\n" +
    "                </fieldset>\n" +
    "            </div>\n" +
    "            <div ng-repeat=\"option in ctrl.screenData.arAdditionalCustomOptionItems\" >\n" +
    "                <fieldset>\n" +
    "                    <legend class=\"col-md-12 legend-element\">{{option.name}}</legend>\n" +
    "\n" +
    "                <div ng-repeat=\"customOption in option.customOptions\" ng-class=\"{'child-checkbox': customOption.id === 'INCLUDEPAYBYPHONE' ||\n" +
    "                customOption.id === 'INCLUDEPAYONLINE' || customOption.id === 'PAYMENTWEBSITEINTEXT' || customOption.id === 'INCLUDEPAYBYMAIL',\n" +
    "                'parent-checkbox': customOption.id === 'INCLUDEARPAYSTUB'}\">\n" +
    "                    <div ng-if=\"(customOption.id !=='INCLUDEPAYBYPHONE' && customOption.id !=='INCLUDEPAYONLINE' && customOption.id !=='PAYMENTWEBSITEINTEXT'\n" +
    "                                && customOption.id !== 'INCLUDEPAYBYMAIL')\">\n" +
    "                        <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                            ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                    </div>\n" +
    "                    <div class=\"bmp-additional-sub-option\" ng-if=\"ctrl.model.customItems['INCLUDEARPAYSTUB'].value && ctrl.isNotTraditionalOrTraditionalBOxFormat\">\n" +
    "                        <div ng-if=\"customOption.id ==='INCLUDEPAYBYPHONE' || customOption.id ==='INCLUDEPAYBYMAIL'\">\n" +
    "                            <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                            ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                        </div>\n" +
    "                        <div class=\"invoice-pay-online-inputs\" ng-if=\"customOption.id === 'INCLUDEPAYONLINE' && ctrl.model.customItems['INCLUDEARPAYSTUB'].value\">\n" +
    "                            <bmp-additional-custom-options additional-option=\"customOption\"\n" +
    "                                ng-model=\"ctrl.customItems[customOption.id]\"></bmp-additional-custom-options>\n" +
    "                            <div ng-if=\"ctrl.model.customItems['INCLUDEPAYONLINE'].value === true\">\n" +
    "                                <input ng-model=\"ctrl.customItems['PAYMENTWEBSITEINTEXT'].value\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                 </div>\n" +
    "                </fieldset>\n" +
    "                <div ng-if=\"ctrl.model.customItems['INCLUDEARPAYSTUB'].value && ctrl.onIncludePayStubChange()\"></div>\n" +
    "        </div>\n" +
    "        <bm-practice-billing-statement-format-wizard-preview model=\"ctrl.model\" step=\"STATEMENTARINFO\" class=\"pull-right\"></bm-practice-billing-statement-format-wizard-preview>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-carousel-card.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-carousel-card.html",
    "<div>\n" +
    "    <p data-qe-id=\"{{card.dataQeId }}\" id=\"{{card.dataQeId}}\">{{card.name}}</p>\n" +
    "    <img class=\"statement-format-wizard-card-report-image\" src=\"{{card.genericPreviewImageUrl}}\" width=\"100%\" height=\"240\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-main.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-main.html",
    "<div>* {{'Bluemoon.DMS.Approvals.ConfirmModal.RequiredField' | translate}}</div><br/>\n" +
    "<div class=\"row\">\n" +
    "    <!-- /* i18nextract */'Core.Captions.CompanyLayoutOption.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"name\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.CompanyLayoutOption.Name' | translate | bmRequiredMark}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.model.data, 'name')\"\n" +
    "        class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "        <input autocomplete=\"name\"\n" +
    "            name=\"name\"\n" +
    "            type=\"text\"\n" +
    "            class=\"form-control input-lg interactiveElement\"\n" +
    "            aria-labelledby=\"name-label name-error\"\n" +
    "            data-ng-model=\"vm.model.data.name\"\n" +
    "            data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "            bmp-default-focus\n" +
    "            data-ng-required=\"true\"\n" +
    "            data-bmp-entity-code=\"\"\n" +
    "            data-bmp-entity-code-id=\"vm.model.data.id\"\n" +
    "            data-bmp-entity-code-type=\"company-layout-options\"\n" +
    "            data-bmp-entity-code-options=\"{reportLayoutTypeId: 'STATEMENT'}\"\n" +
    "            data-ng-change=\"vm.detail.clearErrorFor(vm.model.data, 'name')\" />\n" +
    "        <div class=\"pending-msg\" ng-show=\"vm.form.name.$dirty && vm.form.name.$pending\" translate=\"Bluemoon.Billing.StatementFormatWizard.NonUniqueNamePendingMsg\"></div>\n" +
    "        <div class=\"valid-msg\" ng-show=\"vm.form.name.$dirty && vm.form.name.$valid\" translate=\"Bluemoon.Billing.StatementFormatWizard.ValidNameMsg\"></div>\n" +
    "        <div class=\"msg-space-holder\" ng-show=\"!vm.form.name.$dirty && !vm.form.name.$valid && !vm.form.name.$pending\" translate=\"Bluemoon.Billing.InvoiceFormatWizard.ValidNameMsg\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <bmp-carousel name=\"reportDefinition\" bmp-carousel-cards=\"vm.styleCards\" bmp-carousel-card-template-url=\"vm.styleCardsTemplateUrl\" ng-model=\"vm.$reportDefinition\"></bmp-carousel>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!-- /* i18nextract */'Bluemoon.Billing.StatementFormatWizard.ShowStylesForCombo' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.StatementFormatWizard.ShowStylesForCombo' | translate | bmRequiredMark}}\"\n" +
    "        class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"custom\"\n" +
    "                custom-items=\"vm.countryIds\"\n" +
    "                ng-model=\"vm.styleCountryId\"\n" +
    "                value-property=\"id\"\n" +
    "                on-change=\"vm.refreshVisibleCards()\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-5 col-sm-6 col-xs-12\"\n" +
    "        data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.StatementFormatWizard.Logo' | translate}}\">\n" +
    "        <div bento-busy-loader=\"vm.model.$logoLoading\">\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" id=\"stmtLogoAddBtn\" tabindex=\"0\" href=\"\"\n" +
    "            ng-click=\"vm.changeLogo()\" translate=\"Bluemoon.Billing.StatementFormatWizard.Logo.Add\" ng-show=\"!vm.model.$logo.content\" ng-disabled=\"vm.model.$logoLoading\"></a>\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" tabindex=\"0\" href=\"\"\n" +
    "            ng-click=\"vm.changeLogo()\" translate=\"Bluemoon.Billing.StatementFormatWizard.Logo.Change\" ng-show=\"!!vm.model.$logo.content\"></a>\n" +
    "            <a class=\"btn btn-default invoice-format-wizard-img-btn-default interactiveElement\" role=\"button\" tabindex=\"0\" href=\"\"\n" +
    "            ng-click=\"vm.removeLogo()\" translate=\"Bluemoon.Billing.StatementFormatWizard.Logo.Remove\" ng-show=\"!!vm.model.$logo.content\"></a>\n" +
    "            <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-7 col-sm-6 col-xs-12\"\n" +
    "        data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Billing.StatementFormatWizard.Logo.Preview' | translate}}\"\n" +
    "        ng-if=\"!!vm.model.$logo.content\">\n" +
    "        <img class=\"bm-billing-statement-format-wizard-logo-preview\" ng-src=\"{{ vm.model.$logo.content }}\" />\n" +
    "    </div>\n" +
    "    <div ng-if=\"(vm.model.data.reportDefinition.code === 'STATEMENTUSCONTEMPORARYCOLORED' || vm.model.data.reportDefinition.code === 'STATEMENTCACONTEMPORARYCOLORED') || ( vm.model.data.reportDefinition.code === 'STATEMENTUSWINDOWEDENVELOPE' || vm.model.data.reportDefinition.code === 'STATEMENTUSCONTEMPORARY') || ( vm.model.data.reportDefinition.code === 'STATEMENTCACONTEMPORARY' || vm.model.data.reportDefinition.code === 'STATEMENTCAWINDOWEDENVELOPE') \" class=\"row accent-color\" data-bmp-control-group=\"\">\n" +
    "        <div class=\"col-xs-12\" translate=\"Onvio.Setup.Theme.AccentColor\"></div>\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <div class=\"accent-color-picker\">\n" +
    "                <div class=\"swatch\" data-ng-style=\"{'background-color' : '#fff' }\"\n" +
    "                    ng-class=\"{'none-selected': vm.isNoneColorOptionSelected, 'selected': !vm.isNoneColorOptionSelected}\" ng-click=\"vm.selectColor('')\">\n" +
    "                    <i class=\"bento-icon-close-x\"></i>\n" +
    "                </div>\n" +
    "                <div class=\"swatch\" ng-repeat=\"accentColor in vm.accentColors\"\n" +
    "                    data-ng-style=\"{'background-color' : accentColor.color }\" ng-class=\"{'selected': accentColor.selected}\"\n" +
    "                    ng-click=\"vm.selectColor(accentColor.color)\">\n" +
    "                    <i class=\"bento-icon-checkmark\" ng-if=\"accentColor.selected\"></i>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"custom-hex-options col-xs-12\">\n" +
    "            <bmp-additional-custom-options additional-option=\"vm.colorOptions\"\n" +
    "                ng-model=\"vm.customHexCodeOption\"></bmp-additional-custom-options>\n" +
    "            <!-- <input ng-model=\"ctrl.colorOptionValues['CUSTOMHEXCODEVALUE'].value\" /> -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"customHexCode\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Billing.InvoiceFormatWizard.CustomHexCode' | translate | bmRequiredMark}}\"\n" +
    "                class=\"custom-hex col-sm-6 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"customHexCode\" type=\"text\" class=\"custom-hex-input form-control input-sm interactiveElement\"\n" +
    "                    aria-labelledby=\"customHexCode-label customHexCode-error-msg\"\n" +
    "                    data-ng-model=\"vm.colorOptionValues['CUSTOMHEXCODEVALUE'].value\"\n" +
    "                    data-ng-disabled = \"!vm.colorOptionValues['CUSTOMHEXCODE'].value\"\n" +
    "                    data-ng-required=\"{{vm.colorOptionValues['CUSTOMHEXCODE'].value ? true : false}}\" customHexCodeValidation/>\n" +
    "                <div id=\"customHexCode-error-msg\" class=\"invalid-msg\" ng-show=\"vm.form.customHexCode.$error.customHexCodeValidation\"\n" +
    "                    translate=\"Bluemoon.Billing.InvoiceFormatWizard.CustomHexCode.ValidateMessage\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-preview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-format-wizard/pages/statement-format-wizard-preview.html",
    "<div style=\"display:grid; padding-bottom:5px;\">\n" +
    "    <button class=\"btn btn-default\"\n" +
    "        ng-click=\"ctrl.preview()\">\n" +
    "{{'Bluemoon.Billing.StatementFormatWizard.PreviewFormat' | translate}}\n" +
    "    </button>\n" +
    "</div>\n" +
    "<img class=\"statement-format-wizard-card-report-image\" ng-src=\"{{ctrl.getImageSource()}}\" width=\"185\" height=\"240\">");
}]);

angular.module("main/src/format-templates/statement-formats-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/format-templates/statement-formats-list.html",
    "<div>\n" +
    "    <h1 class=\"no-top-margin\"\n" +
    "        data-qe-id=\"header-title\">{{'Bluemoon.Billing.StatementFormats.HeaderTitle' | translate}}</h1>\n" +
    "\n" +
    "    <!-- Grid -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                    bmp-grid-service=\"vm.companyLayoutOptionService\"></bmp-grid>\n" +
    "            </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/late-fees/late-fee-detail-grid-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/late-fees/late-fee-detail-grid-template.html",
    "<bm-practice-billing-late-fee-detail details=\"$item.$lateFeeDetails\" id=\"$item.id\" row=\"$row\"></bm-practice-billing-late-fee-detail>");
}]);

angular.module("main/src/late-fees/late-fee-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/late-fees/late-fee-detail.html",
    "<wj-flex-grid\n" +
    "    control=\"vm.flexGrid\"\n" +
    "    class=\"bento-flex-grid billing-late-fees-detail-grid\"\n" +
    "    items-source=\"vm.details\"\n" +
    "    item-formatter=\"vm.itemFormatter\"\n" +
    "    selection-mode=\"None\"\n" +
    "    headers-visibility=\"Column\"\n" +
    "    is-read-only=\"false\"\n" +
    "    style=\"height:auto\"\n" +
    "    id=\"bm-detailBillForm-billableGrid\">\n" +
    "        <wj-flex-grid-column\n" +
    "            binding=\"reference\"\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"*\"\n" +
    "            header=\"{{'Core.Captions.LateFeeDetail.Reference' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column\n" +
    "            binding=\"entryDescription\"\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"*\"\n" +
    "            header=\"{{'Core.Captions.LateFeeDetail.EntryDescription' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column\n" +
    "            binding=\"entryDate\"\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"*\"\n" +
    "            header=\"{{'Core.Captions.LateFeeDetail.EntryDate' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column\n" +
    "            binding=\"dueDate\"\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"*\"\n" +
    "            header=\"{{'Core.Captions.LateFeeDetail.DueDate' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column\n" +
    "            binding=\"postedOpenAmount\"\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"*\"\n" +
    "            align=\"right\"\n" +
    "            format=\"c2\"\n" +
    "            header=\"{{'Bluemoon.Billing.LateFee.PastDueAmount' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column\n" +
    "            is-read-only=\"true\"\n" +
    "            width=\"150\"\n" +
    "            data-type=\"1\"\n" +
    "            align=\"right\"\n" +
    "            header=\"{{'Core.Captions.LateFeeDetail.Amount' | translate}}\">\n" +
    "            <div ng-form=\"lateFeeDetailAmountForm\" id=\"lateFeeDetailAmountForm\">\n" +
    "                <span ng-if=\"$item.$amountIsOverridden\"\n" +
    "                    class=\"bento-icon-info bmp-wijmo-table-info-icon bmp-wijmo-table-info-icon-align-left billing-late-fees-overridden-tooltip\"\n" +
    "                    data-tooltip-placement=\"top\"\n" +
    "                    data-tooltip-trigger=\"mouseenter\"\n" +
    "                    data-tooltip-append-to-body=\"true\"\n" +
    "                    data-uib-tooltip=\"{{'Core.Captions.TimeAndExpense.AmountIsOverridden' | translate }}\"></span>\n" +
    "                <input\n" +
    "                    style=\"text-align: right; font-size: inherit; height: 36px\"\n" +
    "                    name=\"Amount\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control\"\n" +
    "                    bmp-field-error=\"Core.Captions.LateFeeSummary.Amount\"\n" +
    "                    data-ng-model=\"$item.$amount\"\n" +
    "                    data-ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-ng-keydown=\"vm.onKeydown($event, $row, $col)\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-ng-change=\"vm.onChanged($item)\"\n" +
    "                    data-ng-disabled=\"$item.$isPosted\"\n" +
    "                    bmp-select-on-focus=\"true\"/>\n" +
    "            </div>\n" +
    "        </wj-flex-grid-column>\n" +
    "</wj-flex-grid>\n" +
    "");
}]);

angular.module("main/src/late-fees/late-fees.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/late-fees/late-fees.html",
    "<h1 class=\"no-top-margin\" translate=\"Bluemoon.Billing.LateFee.Title\"></h1>\n" +
    "\n" +
    "<div class=\"row\" ng-form=\"lateFeeForm\">\n" +
    "\n" +
    "    <!-- Assess Late Fees Through -->\n" +
    "    <div class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"openDateInclusive\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Billing.LateFee.AssessThrough' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"\">\n" +
    "            <bmp-bento-datepicker-wrapper name=\"openDateInclusive\" id=\"openDateInclusive\"\n" +
    "                                          ng-required=\"true\"\n" +
    "                                          ng-model=\"vm.customParams.openDateInclusive\"\n" +
    "                                          ng-change=\"vm.refreshGrid()\"></bmp-bento-datepicker-wrapper>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                  bmp-grid-service=\"vm.lateFeeProxy\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/review-invoices/invoice-reversal-modal/invoice-reversal-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/review-invoices/invoice-reversal-modal/invoice-reversal-modal.html",
    "<ng-form name=\"invoiceReversalForm\">\n" +
    "    <div bento-busy-loader=\"vm.loadingInvoiceReversalModal\" bento-busy-loader-size=\"small\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeModal()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "        <div class=\"modal-header\">\n" +
    "            <span translate=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.ReverseInvoice' }}\"></span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"modal-body\">\n" +
    "            <!-- 1st row -->\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Client -->\n" +
    "                <div class=\"col-md-6 col-xs-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"client\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.Client' | translate }}\">\n" +
    "                        <input autocomplete=\"off\" name=\"client\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-client-text\"\n" +
    "                            type=\"text\"\n" +
    "                            readonly class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.invoiceReversalItem.client.name\"\n" +
    "                            data-bmp-control-group-field=\"Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.Client\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Invoice Number -->\n" +
    "                <div class=\"col-md-3 col-xs-6\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"invoiceNumber\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.InvoiceNumber' | translate }}\">\n" +
    "                        <input autocomplete=\"off\" name=\"invoiceNumber\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-invoiceNumber-text\"\n" +
    "                            type=\"text\"\n" +
    "                            readonly class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.invoiceReversalItem.entryNumber\"\n" +
    "                            data-bmp-control-group-field=\"Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.InvoiceNumber\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Invoice Amount -->\n" +
    "                <div class=\"col-md-3 col-xs-6\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"invoiceAmount\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.InvoiceAmount' | translate }}\">\n" +
    "                        <!-- TODO: Bind with correct Invoice Amount value -->\n" +
    "                        <input autocomplete=\"off\"\n" +
    "                            name=\"invoiceAmount\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-invoiceAmount-text\"\n" +
    "                            type=\"text\"\n" +
    "                            readonly class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.invoiceReversalItem.amount\"\n" +
    "                            data-bmp-big-number=\"'c2'\"\n" +
    "                            data-bmp-control-group-field=\"Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.InvoiceAmount\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- 2nd row -->\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Reversal Date -->\n" +
    "                <div class=\"col-sm-6 col-xs-12\">\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.ReversalDate' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"reversalDate\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.ReversalDate' | translate | bmRequiredMark }}\"\n" +
    "                        data-bmp-control-group-error=\"vm.reversalDateError\">\n" +
    "                        <bmp-bento-datepicker-wrapper\n" +
    "                            name=\"reversalDate\"\n" +
    "                            id=\"reversalDate\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-reversalDate-datePicker\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-model=\"vm.reversalDate\">\n" +
    "                        </bmp-bento-datepicker-wrapper>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Open Amount -->\n" +
    "                <div class=\"col-sm-3 col-xs-6\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"openAmount\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.OpenAmount' | translate }}\">\n" +
    "                        <!-- TODO: Bind with correct Open Amount value -->\n" +
    "                        <input autocomplete=\"off\"\n" +
    "                            name=\"openAmount\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-openAmount-text\"\n" +
    "                            type=\"text\"\n" +
    "                            readonly class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.openAmount\"\n" +
    "                            data-bmp-big-number=\"'c2'\"\n" +
    "                            data-bmp-control-group-field=\"Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.OpenAmount\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Reversal Amount -->\n" +
    "                <div class=\"col-sm-3 col-xs-6\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"reversalAmount\"\n" +
    "                        data-bmp-control-group-label=\"{{ 'Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.ReversalAmount' | translate }}\">\n" +
    "                        <!-- TODO: bind with correct Reversal Amount value -->\n" +
    "                        <input autocomplete=\"off\"\n" +
    "                            name=\"reversalAmount\"\n" +
    "                            data-qe-id=\"bm-invoiceReversalForm-reversalAmount-text\"\n" +
    "                            type=\"text\"\n" +
    "                            readonly class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.reversalAmount\"\n" +
    "                            data-bmp-big-number=\"'c2'\"\n" +
    "                            data-bmp-control-group-field=\"Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.ReversalAmount\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button type=\"button\"\n" +
    "                data-qe-id=\"bm-invoiceReversalForm-save-button\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                ng-click=\"vm.submit()\"\n" +
    "                ng-disabled=\"vm.submitButtonDisabled()\"\n" +
    "                translate>Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.Submit\n" +
    "            </button>\n" +
    "\n" +
    "            <button type=\"button\"\n" +
    "                data-qe-id=\"bm-invoiceReversalForm-cancel-button\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                ng-click=\"vm.closeModal('Cancel')\"\n" +
    "                translate>Bluemoon.Billing.ReviewInvoices.InvoiceReversalModal.Cancel\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("main/src/review-invoices/review-invoices-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/review-invoices/review-invoices-directive.html",
    "<div bento-busy-loader=\"vm.loaderBusy\">\n" +
    "    <h1 class=\"no-top-margin\"\n" +
    "        data-qe-id=\"header-title\">{{'Bluemoon.Billing.SelectionAndReview.ReviewInvoices' | translate}}</h1>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "            <bmp-date-range-selector\n" +
    "                name=\"bm-reviewInvoices-dateRangeSelector\"\n" +
    "                data-qe-id=\"bm-reviewInvoices-dateRangeSelector\"\n" +
    "                bmp-date-range-selector-options=\"vm.dateRangeSelectorOptions\"\n" +
    "                bmp-date-range-selector-options-default=\"WEEK\"\n" +
    "                bmp-date-range-selector-changed=\"vm.onFilterChange({dateRangeValueId: dateRangeId, startDate: startDate, endDate: endDate})\">\n" +
    "            </bmp-date-range-selector>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-4 bm-billing-unposted-and-unapproved\">\n" +
    "            <bmp-posted-and-approved-filters ng-if=\"vm.approvalEnabled\"\n" +
    "                                                posted=\"vm.postedFilter\"\n" +
    "                                                approved=\"vm.approvedFilter\"\n" +
    "                                                on-changed=\"vm.onFilterChange()\"\n" +
    "                                                user-settings-key=\"vm.userSettingsKey\">\n" +
    "            </bmp-posted-and-approved-filters>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Grid -->\n" +
    "    <div class=\"row\">\n" +
    "        <!-- make large width 11 to fix a horizontal scrollbar bug w/ wijmo grid-->\n" +
    "        <div class=\"col-xs-12\">\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.gridDefinition\"\n" +
    "                    bmp-grid-service=\"vm.arSummaryService\"\n" +
    "                    bmp-grid-before-load=\"vm.gridLoading($sender)\"></bmp-grid>\n" +
    "            </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/user-preferences-setup/user-preferences-billing-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/user-preferences-setup/user-preferences-billing-component.html",
    "<h3 data-ng-show=\"$ctrl.detail.isLoadingData()\">{{$ctrl.detail.busyText}}</h3>\n" +
    "<ng-form id=\"userPreferencesTimeAndBillingBillingForm\" name=\"userPreferencesTimeAndBillingBillingForm\" data-ng-hide=\"$ctrl.detail.isLoadingData()\" autocomplete=\"off\">\n" +
    "    <h3>{{'Bluemoon.Billing.UserPreferencesSetup.Section.FieldDefaultsAndSettings' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Default Invoice Date -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"defaultInvoiceDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefBilling.DefaultInvoiceDate' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'defaultInvoiceDate')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"user-preference-billing-default-invoice-date\"\n" +
    "                        name=\"defaultInvoiceDate\"\n" +
    "                        data-qe-id=\"defaultInvoiceDate\"\n" +
    "                        ng-model=\"$ctrl.data.defaultInvoiceDate\"\n" +
    "                        required=\"true\"\n" +
    "                        append-to-parent=\".preferences-pane\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Default Wip Thru Date -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"defaultWipThruDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefBilling.DefaultWipThruDate' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'defaultWipThruDate')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"user-preference-default-wip-thru-date\"\n" +
    "                        name=\"defaultWipThruDate\"\n" +
    "                        data-qe-id=\"defaultWipThruDate\"\n" +
    "                        ng-model=\"$ctrl.data.defaultWipThruDate\"\n" +
    "                        required=\"true\"\n" +
    "                        append-to-parent=\".preferences-pane\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("server-check/index.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("server-check/index.html",
    "<Status xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns=\"http://schemas.datacontract.org/2004/07/Cobalt.BlueMoonClients.Web.Models\">\n" +
    "    <Resources>\n" +
    "        <Result>OK</Result>\n" +
    "    </Resources>\n" +
    "</Status>\n" +
    "");
}]);
